<template>
  <div>
    <DialogComponent ref="dialog" />
    <Modal :mensagem="erro" @resposta="respConfirm" />
    <!-- MODAL - REF:erroPush -->
    <b-modal ref="erroPush" @ok="confirmaErroPush" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>{{this.erroPushMsg}}</p>
    </b-modal>
    <!-- FIM MODAL - REF:erroPush -->
    <!-- MODAL - REF:declaracaoInequivoca -->
    <b-modal ref="declaracaoInequivoca" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>{{ this.erro }}</p>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="success" class="float-right" @click="confirmarMunicipioDeclaracao(true)">
            Confirmar
          </b-button>
          <b-button variant="danger" class="float-left" @click="confirmarMunicipioDeclaracao(false)">
            Corrigir Dados
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- FIM MODAL - REF:declaracaoInequivoca -->
    <!-- MODAL - REF:confirmaSemCertificado -->
    <b-modal ref="confirmaSemCertificado" size="x1" title="Atenção" @ok="redirecionaPainel" no-close-on-backdrop no-close-on-esc>
      <template #modal-header="">
        <h5>Atenção</h5>
      </template>
      Para utilizar o serviço de Pedido de Protesto é necessário estar logado por meio de Certificado Digital ICP-Brasil ou niveis Prata ou Ouro via acesso .GOV.BR
    </b-modal>
    <!-- FIM MODAL - REF:confirmaSemCertificado -->
    <!-- MODAL - REF:modalBoleto -->
    <b-modal ref="modalBoleto" size="xl" scrollable title="Boleto" id="modal-dialog">
      <b-embed type="iframe" aspect="1by1" :src="ds_endereco_boleto"  allowfullscreen v-if="ds_endereco_boleto">
      </b-embed>
    </b-modal>
    <!-- FIM MODAL - REF:modalBoleto -->
    <!-- MODAL - REF:erro -->
    <b-modal ref="erro" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>{{ this.erro }}</p>
    </b-modal>
    <!-- FIM MODAL - REF:erro -->
    <!-- LOADING SPINNER -->
    <template v-if="loading">
      <div class="text-center" style="background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: 10002;
        margin: 0;
        top: 0;
        padding-top: 20%;">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Text Centered"></b-spinner>
        <br /><span style="color: #004e86">Processando Aguarde...</span>
      </div>
    </template>
    <!-- FIM LOADING SPINNER -->
    <Header :home="false" :logged="logged" :arealogada="true" />
    <div id="painel" class="container-fluid">
      <b-row>
        <!-- MENU LATERAL -->
        <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <!-- FIM MENU LATERAL -->
        <!-- CORPO -->
        <b-col cols="12" md="8" lg="9" class="flex container-pedidoprotesto pb-5" style="padding: 0;">
          <b-container fluid id="painelcontainerfluid" class="pb-5">
            <!-- BREADCRUMB -->
            <b-row>
              <b-col cols="10" style="padding: 0;">
                <b-breadcrumb :items="breadCrumb"></b-breadcrumb>
              </b-col>
              <b-col cols="2" style="padding: 0.75rem 1rem;">
                <b-link class="btn-voltar" href="/painel" style="text-decoration:none;font: normal normal 200 16px/24px 'Kanit', sans-serif;color:var(--secondary-color);">
                  Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
              </b-col>
            </b-row>
            <!-- FIM BREADCRUMB -->
            <!-- FORM / FORMPROCURACAO -->
            <template v-if="!ic_protesto_solicitado">
              <b-form name="frmProcuracao" id="frmProcuracao">
                <h1 class="text-primary mt-5 text-center">{{form.dados_divida.especie.code === 'CH' ? 'Solicitar envio de cheque a protesto' : 'Solicitar envio de título a protesto'}}</h1>
                <b-tabs v-model="tabIndex" content-class="mt-3" align="center" class="ul-ieptb">
                  <!-- STEP 1 - Dados da Dívida -->
                  <b-tab title="01" class="tab-protesto" active>
                    <!-- CARD DADOS DIVIDA ID#dados_divida -->
                    <b-card id="card_dados_divida" border-variant="primary-ieptb" header-text-variant="primary-ieptb" class="card-ieptb card-protesto">
                      <template v-slot:header>
                        {{form.dados_divida.especie.code === 'CH' ? 'Dados do Cheque' : 'Informações da Dívida'}}
                        <span v-b-popover.hover.top="'Dados do título ou documento de dívida que esta sendo apresentando a protesto'" title="Informações da Divida" class="infolet">i</span>
                      </template>
                      <b-card-text class="pb-3">
                        <b-row><b-col><h4 class="mt-2">Dados da dívida</h4></b-col></b-row>
                        <b-row class="mt-2">
                          <b-col cols="12" md="12">
                            <label for="especie">Espécie</label>
                            <v-select id="especie" :disabled="!(estados.length>0)" v-model="form.dados_divida.especie" :options="especies" :state="validations.dados_divida_especie" :class="{'is-invalid': !validations.dados_divida_especie}" @focusout.native="onTouchField('especie', $event)" required >
                              <template #no-options>Nenhuma opção disponível...</template>
                            </v-select>
                            <b-form-invalid-feedback :state="validations.dados_divida_especie">Informe a Espécie.</b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                        <!-- CONDICIONAL - CAMPO: justificativa_cheque - especie == 'CH' -->
                        <template v-if="form.dados_divida.especie.code == 'CH'">
                          <b-row class="mt-2">
                            <b-col cols="12" md="12">
                              <label for="justificativa_cheque">Justificativa da devolução do cheque</label>
                              <b-form-textarea id="justificativa_cheque"
                                rows="3"
                                v-model.trim="form.dados_divida.justificativa_cheque"
                                :state="form.dados_divida.justificativa_cheque.length >= 10"
                                maxlength="80"
                                placeholder="Indique a justificativa da devolução do cheque. (No mínimo 10 caracteres, no máximo, 80)"
                                no-resize
                              ></b-form-textarea>
                              <b-form-invalid-feedback :state="form.dados_divida.justificativa_cheque.length >= 10">Justificativa não possui o tamanho requerido</b-form-invalid-feedback>
                              <b-form-text v-show="form.dados_divida.justificativa_cheque.length >= 10" id="helpJustificativaCheque">Máximo de 80 caracteres. ({{80 - form.dados_divida.justificativa_cheque.length}} restantes)</b-form-text>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- FIM CONDICIONAL - CAMPO: justificativa_cheque - especie == 'CH' -->
                        <b-row>
                          <b-col cols="12" md="6">
                            <label for="dados_divida_numero">Número</label>
                            <b-input id="dados_divida_numero"
                              v-model="form.dados_divida.numero"
                              maxlength="11"
                              placeholder="Número"
                              :state="validations.dados_divida_numero"
                              @blur="form.dados_divida.nosso_numero = form.dados_divida.numero"
                              @focusout.native="onTouchField('numero', $event)"
                              required
                            ></b-input>
                            <b-form-invalid-feedback :state="validations.dados_divida_numero">Infome o número.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="3">
                            <label for="dados_divida_dt_emissao">Data Emissão</label>
                            <b-input id="dados_divida_dt_emissao"
                              v-model="form.dados_divida.dt_emissao"
                              :state="validations.dados_divida_dt_emissao"
                              type="date"
                              maxlength="10"
                              :max="maxDate"
                              :min="minDate"
                              @focusout.native="onTouchField('dt_emissao', $event)"
                              required
                            >
                            </b-input>
                            <b-form-invalid-feedback :state="validations.dados_divida_dt_emissao">Data Emissão informada é inválida.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="3">
                            <label for="dados_divida_dt_vencimento">Data Vencimento</label>
                            <b-input id="dados_divida_dt_vencimento"
                              v-model="form.dados_divida.dt_vencimento"
                              :state="validations.dados_divida_dt_vencimento"
                              type="date"
                              maxlength="10"
                              :max="maxDate"
                              :min="minDate"
                              @focusout.native="onTouchField('dt_vencimento', $event)"
                              required
                            >
                            </b-input>
                            <b-form-invalid-feedback :state="validations.dados_divida_dt_vencimento">Informe a Data Vencimento menor que hoje e maior que a data de emissão.</b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col cols="12" md>
                            <label for="endosso">
                              Endosso
                              <span id="pop_endosso" class="infolet">i</span>
                              <b-popover target="pop_endosso" triggers="hover" placement="right">
                                <template v-slot:title>Endosso</template>
                                Declaração que transmite ordens ao título ou
                                documento de dívida. Refere-se a relação entre
                                Apresentante e Sacador.
                                <p class="mt-4 mb-3">
                                  <b>Translativo - </b>
                                  Transfere o crédito do
                                  título ou documento de dívida do Sacador ao
                                  Apresentante.
                                </p>
                                <p class="mb-3">
                                  <b>Mandato - </b>
                                  Autoriza o Apresentante a
                                  enviar ou receber créditos de títulos ou
                                  documentos de dívida.
                                </p>
                                <p>
                                  <b>Sem Endosso - </b>
                                  Apresentante / Sacador são a
                                  mesma pessoa, não havendo autorização de poderes.
                                </p>
                              </b-popover>
                            </label>
                            <v-select id="endosso" v-model="form.dados_divida.endosso_selecionada" :options="endosso" :searchable="false" :clearable="false" required>
                              <template #no-options>Nenhuma opção disponível...</template>
                            </v-select>
                          </b-col>
                          <!-- CONDICIONAL - CAMPO:aceite - especie == listAceiteDeclaracao -->
                          <template v-if="listAceiteDeclaracao.indexOf(form.dados_divida.especie.code) > -1 ">
                            <b-col cols="12" md>
                              <label for="dados_divida_aceite">
                                Aceite
                                <span id="pop_aceite" class="infolet">i</span>
                                <b-popover target="pop_aceite" triggers="hover" placement="top">
                                  <template v-slot:title>Aceite</template>
                                  Ato pelo qual o devedor reconhece formalmente a dívida do título ou documento de dívida emitido.
                                </b-popover>
                              </label>
                              <v-select id="dados_divida_aceite" v-model="form.dados_divida.aceite_selecionada" :options="aceite" :searchable="false" :clearable="false" required>
                                <template #no-options> Nenhuma opção disponível...</template>
                              </v-select>
                            </b-col>
                          </template>
                          <!-- FIM CONDICIONAL - CAMPO:aceite - especie == listAceiteDeclaracao -->
                          <b-col cols="12" md>
                            <label for="dados_divida_tipo_protesto">
                              Tipo de Protesto
                              <span id="pop_finalidade_pedido" class="infolet">i</span>
                              <b-popover target="pop_finalidade_pedido" triggers="hover" placement="right">
                                <template v-slot:title>Tipo de Protesto</template>
                                <p class="mb-3">
                                  <b>Comum - </b>
                                  O protesto de títulos que ocorre de acordo com as normas gerais estabelecidas pela Lei nº 9.492/97, tem como objetivo garantir a segurança e a eficácia do processo de cobrança de dívidas.
                                </p>
                                <p class="mb-3">
                                  <b>Fins Fiscais - </b>
                                  Se você for pessoa jurídica tributada com base no lucro real, e desejar registrar como perda este crédito, conforme o art. 9º-A da Lei 9.430/96, selecione esta opção.
                                </p>
                                <p>
                                  <b>Fins Falimentares - </b>
                                  Protesto por motivo de falência
                                </p>
                              </b-popover>
                            </label>
                            <v-select id="dados_divida_tipo_protesto" v-model="tipo_protesto" :options="tipos_protesto" :disabled="bloqueio9430" :searchable="false" :clearable="false">
                              <template #no-options> Nenhuma opção disponível...</template>
                            </v-select>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col cols="12" md="6">
                            <label for="dados_divida_valor_titulo">{{form.dados_divida.especie.code === 'CH' ? 'Valor do Cheque' : 'Valor do Titulo'}}</label>
                            <b-form-input id="dados_divida_valor_titulo"
                              v-model="form.dados_divida.valor"
                              placeholder="R$ 0,00"
                              :formatter="formataMoeda"
                              maxlength="19"
                              :state="validations.dados_divida_valor"
                              @focusout.native="onTouchField('valor', $event)"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="validations.dados_divida_valor">
                              {{form.dados_divida.especie.code === 'CH' ? 'Preencha o Valor do Cheque.' : 'Preencha o Valor do Título.'}}
                            </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="dados_divida_valor_protestado">Valor a Protestar</label>
                            <b-form-input id="dados_divida_valor_protestado"
                              v-model="form.dados_divida.saldo"
                              placeholder="R$ 0,00"
                              :formatter="formataMoeda"
                              maxlength="19"
                              :state="validations.dados_divida_saldo"
                              @focusout.native="onTouchField('saldo', $event)"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="validations.dados_divida_saldo">Preencha o Valor a Protestar.</b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                        <!-- CONDICIONAL - CAMPO: Praça de Protesto - especie == 'NP','NPR','CH' -->
                        <template v-if="['NP','NPR','CH'].includes(form.dados_divida.especie.code)">
                          <b-row><b-col><hr /></b-col></b-row>
                          <b-row><b-col><h4 class="mt-2">Praça de Protesto</h4></b-col></b-row>
                          <b-row>
                            <b-col md="4">
                              <label for="np_uf">UF</label>
                              <v-select id="np_uf" v-model="form.np_cd_uf_selecionada" :options="estados" :state="validations.np_cd_uf" :searchable="true" :clearable="false" required >
                                <template #no-options>Nenhuma opção disponível...</template>
                              </v-select>
                              <b-form-invalid-feedback :state="validations.np_cd_uf">Informe a UF.</b-form-invalid-feedback>
                            </b-col>
                            <b-col md="8">
                              <label for="np_cidade">Cidade</label>
                              <v-select id="np_cidade" v-model="form.np_cd_ibge_selecionada" :options="municipiosNP" :state="validations.np_cd_ibge" :searchable="true" :clearable="false">
                                <template #no-options>Nenhuma opção disponível...</template>
                              </v-select>
                              <b-form-invalid-feedback :state="validations.np_cd_ibge">Informe a Cidade.</b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- FIM CONDICIONAL - CAMPO: Praça de Protesto - especie == 'NP','NPR','CH' -->
                      </b-card-text>
                    </b-card>
                    <!-- FIM CARD DADOS DIVIDA ID#dados_divida -->
                  </b-tab>
                  <!-- FIM STEP 1 - Dados da Dívida -->
                  <!-- STEP 2 - Dados Credor / Credor Atual [card_cedente] / Credor Original [card_sacador] -->
                  <b-tab title="02" class="tab-protesto">
                    <!-- CARD CREDOR ATUAL / CEDENTE / ENDOSSATARIO ID#_cedente -->
                    <b-card id="card_cedente" border-variant="primary-ieptb" header-text-variant="primary-ieptb" :header="form.dados_divida.especie.code === 'CH' ? 'Informações do Endossatário' : 'Informações do Credor Atual'" class="mb-4 card-ieptb">
                      <template v-slot:header>
                        {{form.dados_divida.especie.code === 'CH' ? 'Informações do Endossatário' : 'Informações do Credor Atual'}}
                        <span v-b-popover.hover.top="'Pessoa Física ou Jurídica que vai receber o pagamento pelo título ou documento de dívida.'" title="Cedente" class="infolet">i</span>
                      </template>
                      <b-card-text class="pb-3">
                        <b-row><b-col><h4 class="mt-2">Dados do {{form.dados_divida.especie.code === 'CH' ? 'Endossatário' : 'Credor Atual'}}</h4></b-col></b-row>
                        <b-row>
                          <b-col cols="12" md="4" lg="4">
                            <label for="documento_cedente">CPF/CNPJ:</label>
                            <b-input id="documento_cedente"
                                v-model="form.documento_cedente"
                                placeholder="Documento"
                                maxlength="18"
                                :state="validations.documento_cedente"
                                person="cedente"
                                @blur="validarDocumento('validations','documento_cedente', $event)"
                                :formatter="formataDocumento"
                                :disabled="travaCedente"
                            >
                            </b-input>
                            <b-form-invalid-feedback :state="validations.documento_cedente">Infome um documento válido.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="4" lg="8">
                            <label for="nome_cedente">Nome completo:</label>
                            <b-input id="nome_cedente"
                                v-model="form.nome_cedente"
                                maxlength="45"
                                placeholder="Nome"
                                :state="validations.nome_cedente"
                                :disabled="travaCedente"
                                required
                            ></b-input>
                            <b-form-invalid-feedback
                                :state="validations.nome_cedente">Infome o nome.</b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="12" lg="12">
                            <hr />
                            <h4 class="text-primary mt-2">Endereço:</h4>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="3">
                            <label for="endereco_cedente_cep">CEP:</label>
                            <b-input id="endereco_cedente_cep"
                                v-model="cedente_cep"
                                maxlength="9"
                                type="text"
                                placeholder="_____-___"
                                @blur="BuscarCep($event.target.value,'endereco_cedente')"
                                :formatter="formataCEP"
                                :disabled="travaCedente"
                            ></b-input>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="6">
                            <label for="endereco_cedente_logradouro">Logradouro:</label>
                            <b-input id="endereco_cedente_logradouro"
                                v-model="form.endereco_cedente.logradouro"
                                maxlength="30"
                                type="text"
                                placeholder="logradouro"
                                @input="formataEndereco('cedente')"
                                :disabled="travaCedente"
                            ></b-input>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="endereco_cedente_numero">Número:</label>
                            <b-input id="endereco_cedente_numero"
                                v-model="form.endereco_cedente.numero"
                                maxlength="5"
                                type="text"
                                placeholder="Numero"
                                @input="formataEndereco('cedente')"
                                :disabled="travaCedente"
                            ></b-input>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="endereco_cedente_complemento">Complemento: <i>(Opcional)</i></label>
                            <b-input id="endereco_cedente_complemento"
                                v-model="form.endereco_cedente.complemento"
                                maxlength="10"
                                type="text"
                                placeholder="Complemento"
                                @input="formataEndereco('cedente')"
                                :disabled="travaCedente"
                            ></b-input>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="endereco_cedente_bairro">Bairro:</label>
                            <b-input id="endereco_cedente_bairro"
                                v-model="form.endereco_cedente.bairro"
                                maxlength="20"
                                type="text"
                                placeholder="Bairro"
                                :disabled="travaCedente"
                            ></b-input>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="endereco_cedente_cidade">Cidade:</label>
                            <b-input id="endereco_cedente_cidade"
                                v-model="form.endereco_cedente.cidade"
                                maxlength="20"
                                type="text"
                                placeholder="Cidade"
                                :disabled="travaCedente"
                            ></b-input>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="endereco_cedente_uf">UF:</label>
                            <v-select id="endereco_cedente_uf" v-model="form.endereco_cedente.uf_selecionada" :options="estados" :disabled="travaCedente" :searchable="true" :clearable="false">
                              <template #no-options> Nenhuma opção disponível...</template>
                            </v-select>
                          </b-col>
                        </b-row>
                      </b-card-text>
                    </b-card>
                    <!-- FIM CARD CREDOR ATUAL / CEDENTE / ENDOSSATARIO ID#_cedente -->
                    <!-- CONDICIONAL CAMPO:card_sacador - endosso == 1, 2 [Mandato, Translativo]-->
                    <template v-if="['1','2'].includes(form.dados_divida.endosso_selecionada.value)">
                      <!-- CARD CREDOR ORIGINAL / SACADOR / ENDOSSANTE ID#_sacador -->
                      <b-card id="card_sacador" border-variant="primary-ieptb" header-text-variant="primary-ieptb" :header="form.dados_divida.especie.code === 'CH' ? 'Informações do Endossante' : 'Informações do Credor Original'" color="red" class="card-ieptb">
                        <template v-slot:header>
                          {{form.dados_divida.especie.code === 'CH' ? 'Informações do Endossante' : 'Informações do Credor Original'}}
                          <span v-b-popover.hover.top="'Pessoa Física ou Jurídica que emitiu o título ou documento de dívida'" title="Informar o Credor" class="infolet">i</span>
                        </template>
                        <b-card-text class="pb-3">
                          <b-row><b-col><h4 class="mt-2">Dados do {{form.dados_divida.especie.code === 'CH' ? 'Endossante' : 'Credor Original'}}</h4></b-col></b-row>
                          <b-row>
                            <b-col cols="12" md="4" lg="4">
                              <label for="documento_sacador">CPF/CNPJ:</label>
                              <b-input id="documento_sacador"
                                  v-model="form.documento_sacador"
                                  placeholder="Documento"
                                  maxlength="18"
                                  :state="validations.documento_sacador"
                                  person="sacador"
                                  @blur="validarDocumento('validations','documento_sacador',$event)"
                                  :formatter="formataDocumento"
                                  required
                              >
                              </b-input>
                              <b-form-invalid-feedback :state="validations.documento_sacador">Infome um documento válido.</b-form-invalid-feedback>
                            </b-col>
                            <b-col cols="12" md="4" lg="8">
                              <label for="nome_sacador">Nome completo:</label>
                              <b-input id="nome_sacador"
                                  v-model="form.nome_sacador"
                                  maxlength="45"
                                  placeholder="Nome"
                                  :state="validations.nome_sacador"
                                  required
                              ></b-input>
                              <b-form-invalid-feedback :state="validations.nome_sacador">Infome o nome.</b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                          <b-row class="mt-2">
                            <b-col cols="12" md="8">
                              <label for="email_sacador">E-mail:</label>
                              <b-input id="email_sacador"
                                  v-model="form.email_sacador"
                                  placeholder="email"
                                  maxlength="50"
                                  :state="validations.email_sacador"
                                  required
                              >
                              </b-input>
                              <b-form-invalid-feedback :state="validations.email_sacador">E-mail inválido.</b-form-invalid-feedback>
                            </b-col>
                            <b-col cols="12" md="4">
                              <label for="celular_sacador">Contato:</label>
                              <b-input id="celular_sacador"
                                  v-model="form.celular_sacador"
                                  :formatter="formataTelefone"
                                  :state="validations.celular_sacador"
                                  maxlength="15"
                                  placeholder="(XX) 9123-4567"
                              ></b-input>
                              <b-form-invalid-feedback :state="validations.celular_sacador">Celular inválido.</b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" md="12" lg="12">
                              <hr />
                              <h4 class="text-primary mt-2">Endereço</h4>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" md="3" lg="3">
                              <label for="sacador_cep">CEP:</label>
                              <b-input id="sacador_cep"
                                v-model="sacador_cep"
                                maxlength="9"
                                type="text"
                                placeholder="_____-___"
                                @blur="BuscarCep($event.target.value,'endereco_sacador')"
                                :state="validations.endereco_sacador_cep"
                                :formatter="formataCEP"
                                required
                              ></b-input>
                              <b-form-invalid-feedback :state="validations.endereco_sacador_cep">CEP inválido.</b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" md="6">
                              <label for="endereco_sacador_logradouro">Logradouro:</label>
                              <b-input id="endereco_sacador_logradouro"
                                  v-model="form.endereco_sacador.logradouro"
                                  maxlength="30"
                                  type="text"
                                  placeholder="Logradouro"
                                  @blur="onTouchField('endereco_sacador_logradouro', $event)"
                                  @input="formataEndereco('sacador')"
                                  :state="validations.endereco_sacador_logradouro"
                                  required
                              ></b-input>
                              <b-form-invalid-feedback :state="validations.endereco_sacador_logradouro">Logradouro inválido.</b-form-invalid-feedback>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label for="endereco_sacador_numero">Número:</label>
                              <b-input id="endereco_sacador_numero"
                                  v-model="form.endereco_sacador.numero"
                                  maxlength="5"
                                  type="text"
                                  placeholder="Número"
                                  @blur="onTouchField('endereco_sacador_numero', $event)"
                                  @input="formataEndereco('sacador')"
                                  :state="validations.endereco_sacador_numero"
                                  required
                              ></b-input>
                              <b-form-invalid-feedback :state="validations.endereco_sacador_numero">Número do endereço inválido.</b-form-invalid-feedback>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label for="sacador_complemento">Complemento: <i>(Opcional)</i></label>
                              <b-input id="sacador_complemento"
                                  v-model="form.endereco_sacador.complemento"
                                  maxlength="10"
                                  type="text"
                                  placeholder="Complemento"
                                  @input="formataEndereco('sacador')"
                              ></b-input>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label for="endereco_sacador_bairro">Bairro:</label>
                              <b-input id="endereco_sacador_bairro"
                                  v-model="form.endereco_sacador.bairro"
                                  maxlength="20"
                                  type="text"
                                  placeholder="Bairro"
                                  @blur="onTouchField('endereco_sacador_bairro', $event)"
                                  :state="validations.endereco_sacador_bairro"
                                  required
                              ></b-input>
                              <b-form-invalid-feedback :state="validations.sacador_bairro">Informe o Bairro.</b-form-invalid-feedback>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label for="endereco_sacador_cidade">Cidade:</label>
                              <b-input id="endereco_sacador_cidade"
                                  v-model="form.endereco_sacador.cidade"
                                  maxlength="20"
                                  type="text"
                                  placeholder="Cidade"
                                  @blur="onTouchField('endereco_sacador_cidade', $event)"
                                  :state="validations.endereco_sacador_cidade"
                                  :disabled="endereco_sacador_cidade_disabled"
                                  required
                              ></b-input>
                              <b-form-invalid-feedback :state="validations.endereco_sacador_cidade">Informe a Cidade.</b-form-invalid-feedback>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label for="endereco_sacador_uf">UF:</label>
                              <v-select id="endereco_sacador_uf"
                                        v-model="form.endereco_sacador.uf_selecionada"
                                        :options="estados" :state="validations.endereco_sacador_uf"
                                        :disabled="endereco_sacador_uf_disabled"
                                        @focusout.native="onTouchField('endereco_sacador_uf', $event)"
                                        :searchable="true" :clearable="false" required>
                                <template #no-options>Nenhuma opção disponível...</template>
                              </v-select>
                              <b-form-invalid-feedback :state="validations.endereco_sacador_uf">Informe a UF .</b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                        </b-card-text>
                      </b-card>
                      <!-- FIM CARD CREDOR ORIGINAL / SACADOR / ENDOSSANTE ID#_sacador -->
                    </template>
                    <!-- FIM CONDICIONAL CAMPO:_sacador  - endosso == 1, 2 [Mandato, Translativo]-->
                  </b-tab>
                  <!-- FIM STEP 2 - Dados Credor / Credor Atual [card_cedente] / Credor Original [card_sacador] -->
                  <!-- STEP 3 - Dados Devedor / Codevedores -->
                  <b-tab title="03" class="tab-protesto">
                    <!-- CARD DEVEDOR ID#_devedor -->
                    <b-card id="card_devedor" border-variant="primary-ieptb" header-text-variant="primary-ieptb" class="card-ieptb">
                      <template v-slot:header>
                        {{form.dados_divida.especie.code === 'CH' ? 'Informações do Emitente' : 'Informações do Devedor'}}
                        <span v-b-popover.hover.top="'Pessoa Física ou Jurídica responsável pelo pagamento do título ou documento de dívida.'" title="Devedor" class="infolet">i</span>
                      </template>
                      <b-card-text>
                        <b-row><b-col><h4 class="mt-2">Dados do {{form.dados_divida.especie.code === 'CH' ? 'Emitente' : 'Devedor'}}</h4></b-col></b-row>
                        <b-row>
                          <b-col cols="12" md="4" lg="4">
                            <label for="documento_devedor">CPF/CNPJ:</label>
                            <b-input id="documento_devedor"
                                v-model="form.documento_devedor"
                                placeholder="Documento"
                                maxlength="18"
                                :state="validations.documento_devedor"
                                person="devedor"
                                @blur="validarDocumento('validations','documento_devedor',$event)"
                                :formatter="formataDocumento"
                                required
                            >
                            </b-input>
                            <b-form-invalid-feedback :state="validations.documento_devedor">Infome um documento válido.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="4" lg="8">
                            <label for="nome_devedor">Nome:</label>
                            <b-input id="nome_devedor"
                                v-model="form.nome_devedor"
                                maxlength="45"
                                placeholder="Nome"
                                :state="validations.nome_devedor"
                                required
                            ></b-input>
                            <b-form-invalid-feedback :state="validations.nome_devedor">Infome o nome.</b-form-invalid-feedback>
                          </b-col>

                        </b-row>
                        <b-row class="mt-2">

                          <b-col cols="12" md="8">
                            <label for="email_devedor">E-mail:</label>
                            <b-input id="email_devedor"
                                v-model="form.email_devedor"
                                placeholder="email"
                                maxlength="50"
                                :state="optionalValidations.email_devedor"
                            >
                            </b-input>
                            <b-form-invalid-feedback :state="optionalValidations.email_devedor">E-mail inválido.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="4">
                            <label for="celular_devedor">Contato:</label>
                            <b-input id="celular_devedor"
                                v-model="form.celular_devedor"
                                :formatter="formataTelefone"
                                maxlength="15"
                                placeholder="(XX) 9123-4567"
                            ></b-input>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="12" lg="12">
                            <hr />
                            <h4 class="text-primary mt-2">Endereço:</h4>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col cols="12" md="3" lg="3">
                            <label for="devedor_cep">CEP:</label>
                            <b-input id="devedor_cep"
                              v-model="devedor_cep"
                              maxlength="9"
                              type="text"
                              placeholder="_____-___"
                              @blur="BuscarCep($event.target.value, 'endereco_devedor')"
                              :state="validations.endereco_devedor_cep"
                              :formatter="formataCEP"
                              required
                            ></b-input>
                            <b-form-invalid-feedback :state="validations.endereco_devedor_cep">CEP inválido.</b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="6">
                            <label for="endereco_devedor_logradouro">Logradouro:</label>
                            <b-input id="endereco_devedor_logradouro"
                                v-model="form.endereco_devedor.logradouro"
                                maxlength="30"
                                type="text"
                                placeholder="Logradouro"
                                @blur="onTouchField('endereco_devedor_logradouro', $event)"
                                @input="formataEndereco('devedor')"
                                :state="validations.endereco_devedor_logradouro"
                                required
                            ></b-input>
                            <b-form-invalid-feedback :state="validations.endereco_devedor_logradouro">Logradouro inválido.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="endereco_devedor_numero">Número:</label>
                            <b-input id="endereco_devedor_numero"
                                v-model="form.endereco_devedor.numero"
                                maxlength="5"
                                type="text"
                                placeholder="Número"
                                @blur="onTouchField('endereco_devedor_numero', $event)"
                                @input="formataEndereco('devedor')"
                                :state="validations.endereco_devedor_numero"
                                required
                            ></b-input>
                            <b-form-invalid-feedback :state="validations.endereco_devedor_numero">Número do endereço inválido.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="devedor_complemento">Complemento: <i>(Opcional)</i></label>
                            <b-input id="devedor_complemento"
                                v-model="form.endereco_devedor.complemento"
                                maxlength="10"
                                type="text"
                                placeholder="Complemento"
                                @input="formataEndereco('devedor')"
                            ></b-input>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="devedor_bairro">Bairro:</label>
                            <b-input id="devedor_bairro"
                                v-model="form.endereco_devedor.bairro"
                                maxlength="20"
                                type="text"
                                placeholder="Bairro"
                                @blur="onTouchField('endereco_devedor_bairro', $event)"
                                :state="validations.endereco_devedor_bairro"
                                required
                            ></b-input>
                            <b-form-invalid-feedback :state="validations.endereco_devedor_bairro">Informe o Bairro.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="devedor_cidade">Cidade:</label>
                            <b-input id="devedor_cidade"
                                v-model="form.endereco_devedor.cidade"
                                maxlength="20"
                                type="text"
                                placeholder="Cidade"
                                @blur="onTouchField('endereco_devedor_cidade', $event)"
                                :state="validations.endereco_devedor_cidade"
                                :disabled="endereco_devedor_cidade_disabled"
                                required
                            ></b-input>
                            <b-form-invalid-feedback :state="validations.endereco_devedor_cidade">Informe a Cidade.</b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label for="devedor_uf">UF:</label>
                            <v-select id="devedor_uf"
                                      v-model="form.endereco_devedor.uf_selecionada"
                                      :options="estados" :state="validations.endereco_devedor_uf"
                                      :class="{'is-invalid': !validations.endereco_devedor_uf}"
                                      @focusout.native="onTouchField('endereco_devedor_uf', $event)"
                                      :disabled="endereco_devedor_uf_disabled" :searchable="true" :clearable="false" required>
                              <template #no-options>Nenhuma opção disponível...</template>
                            </v-select>
                            <b-form-invalid-feedback :state="validations.endereco_devedor_uf">Informe a UF.</b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                        <!-- CONDICIONAL - CAMPO: Praca Protesto - especie == 'CTI' -->
                        <template v-if="['CTI'].includes(form.dados_divida.especie.code)">
                          <b-row><b-col><hr /></b-col></b-row>
                          <b-row><b-col><h4 class="mt-2">Praça de Protesto</h4></b-col></b-row>
                          <b-row>
                            <b-col md="4">
                              <label for="np_uf">UF</label>
                              <v-select id="np_uf" v-model="form.np_cd_uf_selecionada" :options="estados" :state="validations.np_cd_uf" :disabled="!isFieldSet(form.endereco_devedor.cd_uf) && !isFieldSet(form.endereco_devedor.cidade)" :searchable="true" :clearable="false" required>
                                <template #no-options>Nenhuma opção disponível...</template>
                              </v-select>
                              <b-form-invalid-feedback :state="validations.np_cd_uf">Informe a UF.</b-form-invalid-feedback>
                            </b-col>
                            <b-col md="8">
                              <label for="np_cidade">Cidade</label>
                              <v-select id="np_cidade" v-model="form.np_cd_ibge_selecionada" :options="municipiosNP" :state="validations.np_cd_ibge" :disabled="!isFieldSet(form.endereco_devedor.cd_uf) && !isFieldSet(form.endereco_devedor.cidade)" :searchable="true" :clearable="false" required>
                                <template #no-options>Nenhuma opção disponível...</template>
                              </v-select>
                              <b-form-invalid-feedback :state="validations.np_cd_ibge">Informe a Cidade.</b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- FIM CONDICIONAL - CAMPO: Praca Protesto - especie == 'CTI' -->
                      </b-card-text>
                    </b-card>
                    <!-- FIM CARD DEVEDOR ID#_devedor -->
                    <!-- CARDS CODEVEDORES ID#_devedor -->
                    <codevedor :codevedores="aCodevedor" :estados="estados" :docDevedor="form.documento_devedor" :docSacador="form.documento_sacador" :docCedente="form.documento_cedente" :especie="form.dados_divida.especie.code" :key="'codevedores_' + codevedoresKey"
                               @removecodevedor="removerCodevedor" @atualizaCodevedores="attCodevedores" @populaEnderecoCodevedor="populaEnderecoCodevedor" @autalizaBloqueio="updateBloqueio9430"  @errorCodevedor="showError"/>
                    <!-- CONDICIONAL - CAMPO: adicionarCodevedor - especie != 'DMI' -->
                    <b-row>
                      <b-col class="d-flex justify-content-center">
                        <div id="adicionar_codevedor" class="my-5">
                          <b-button id="btn_adicionar_codevedor" :disabled="totalCodevedor >= 8 || form.dados_divida.especie.code == 'DMI'" variant="primary" class="btn-adicionar-codevedor" @click="adicionarCodevedor()">
                            {{form.dados_divida.especie.code === 'CH' ? 'Adicionar Co-emitente' : 'Adicionar Codevedor'}}
                            <font-awesome-icon icon="plus"/>
                          </b-button>
                        </div>
                        <template v-if="totalCodevedor >= 8 || form.dados_divida.especie.code == 'DMI'">
                          <b-popover target="adicionar_codevedor" triggers="hover" placement="left">
                            <template v-if="totalCodevedor >= 8">
                              <p class="mt-3 mb-2"><b>Limite máximo de 8 codevedores/co-emitentes</b></p>
                            </template>
                            <template v-if="form.dados_divida.especie.code == 'DMI'">
                              <p class="mt-3 mb-2"><b>Não é permitido codevedores/co-emitentes para espécie "DMI"</b></p>
                            </template>
                          </b-popover>
                        </template>
                      </b-col>
                    </b-row>
                    <!-- FIM CONDICIONAL - CAMPO: adicionarCodevedor - especie != 'DMI' -->
                    <!-- FIM CARDS CODEVEDORES ID#_devedor -->
                  </b-tab>
                  <!-- FIM STEP 3 - Dados Devedor / Codevedores -->
                  <!-- STEP 4 - Anexo Consentimento -->
                  <b-tab title="04" class="tab-protesto">
                    <!-- CARD ANEXO CONSENTIMENTO ID#ic_anexo_documento -->
                    <b-card id="card_anexo_consentimento" border-variant="primary-ieptb" header-text-variant="primary-ieptb" color="red" class="card-ieptb">
                      <!-- CONDICIONAL - CAMPO:form.ic_anexo_documento - regraAnexo == 'OBRIGATORIO' -->
                      <template v-slot:header>Anexo de documentos</template>
                      <b-card-text class="card_anexo_consentimento">
                        <template v-if="regraAnexo === 'OBRIGATORIO'">
                          <b-row><b-col><h5 class="mt-2"><b-icon variant="danger" icon="file-earmark-check"></b-icon> Anexo Obrigatório</h5></b-col></b-row>
                          <b-row class="px-4">
                            <p>
                              A espécie de protesto selecionada (<b>{{form.dados_divida.especie.label}}</b>) exige obrigatoriamente o envio da Procuração (ou documento comprobatório).
                            </p>
                          </b-row>
                        </template>
                        <!-- FIM CONDICIONAL - CAMPO:form.ic_anexo_documento - regraAnexo == 'OBRIGATORIO' -->
                        <!-- CONDICIONAL - CAMPO:form.ic_anexo_documento - regraAnexo == 'PROIBIDO' -->
                        <template v-else-if="regraAnexo === 'PROIBIDO'">
                          <b-row><b-col><h5 class="mt-2"><b-icon variant="danger" icon="info-circle"></b-icon> Envio não permitido</h5></b-col></b-row>
                          <b-row class="px-4">
                            <p>
                              <b>⚠️ Aviso de Responsabilidade:</b> Para a espécie (<b>{{form.dados_divida.especie.label}}</b>), não é permitido o envio de anexos. Ao optar por prosseguir, você assume que esta ciente de que não poderei incluir documentos neste pedido.
                            </p>
                          </b-row>
                        </template>
                        <!-- FIM CONDICIONAL - CAMPO:form.ic_anexo_documento - regraAnexo == 'PROIBIDO' -->
                        <!-- CONDICIONAL - CAMPO:form.ic_anexo_documento - regraAnexo == 'LIVRE' -->
                        <template v-else>
                          <b-row><b-col><h5 class="mt-2">Deseja incluir algum anexo? <small class="text-muted">(Opcional)</small></h5></b-col></b-row>
                          <b-row class="px-2">
                            <label for="ic_anexo_documento">Enviar anexo?</label>
                          </b-row>
                          <b-row class="px-4">
                            <b-form-checkbox
                                id="ic_anexo_documento"
                                v-model="form.ic_anexo_documento"
                                name="ic_anexo_documento"
                                switch
                                size="md"
                            >
                              <p><b>{{ form.ic_anexo_documento ? 'Sim, vou enviar um arquivo' : 'Não, prefiro prosseguir sem anexo' }}</b></p>
                            </b-form-checkbox>
                          </b-row>
                          <b-row class="px-4">
                            <template v-if="!form.ic_anexo_documento">
                              <p>
                                <b>⚠️ Aviso de Responsabilidade:</b> Ao optar por não enviar anexos, você assume o risco de o cartório devolver (recusar) o seu pedido por falta de provas ou informações complementares. Caso isso ocorra, o pedido será cancelado e você deverá preencher o formulário novamente.
                              </p>
                            </template>
                          </b-row>
                        </template>
                        <!-- CONDICIONAL - CAMPO:form.ic_anexo_documento - regraAnexo == 'LIVRE' -->
                        <template v-if="form.ic_anexo_documento">
                          <b-row class="px-4">
                            <p>
                              <b>⚠️ Compromisso de Envio:</b>
                              Ao optar por prosseguir, você se responsabiliza por concluir o envio de anexo na tela seguinte ao envio do pedido.
                            </p>
                            <p>
                              <b>Atenção:</b>
                              Após finalizar este formulário, você será redirecionado para a etapa de envio de anexo. O protesto não seguirá para processamento enquanto o arquivo não for enviado.<br>
                              Caso ocorra qualquer interrupção na conexão ou erro ao enviar anexo, você deverá acessar a página <strong>"Solicitações de Pedidos"</strong> para verificar o andamento e realizar o envio de anexo manualmente por lá. O protesto não será processado pelo cartório enquanto os documentos selecionados não forem devidamente enviados, podendo gerar o cancelamento automático da solicitação por falta de documentação.
                            </p>
                          </b-row>
                        </template>
                      </b-card-text>
                    </b-card>
                    <!-- FIM CARD ANEXO CONSENTIMENTO ID#ic_anexo_documento -->
                  </b-tab>
                  <!-- FIM STEP 4 - Anexo Consentimento -->
                  <!-- STEP 4 - Confirmação de dados -->
                  <b-tab title="05" class="tab-protesto">
                    <!-- CARDS CONFERE DADOS -->
                    <b-card id="card_confere_dados" border-variant="primary-ieptb" header-text-variant="primary-ieptb" color="red" class="card-ieptb">
                      <b-card-text class="card-confere-dados">
                        <template v-if="form.ic_anexo_documento">
                          <b-alert show variant="warning" class="border-0 shadow-sm">
                            <span class="mb-2">
                              <strong>Atenção:</strong> Não se esqueça de enviar anexo ao finalizar o pedido.
                              <br>
                              Se não for possivel anexar agora, o pedido ficará <strong>pendente</strong>.
                              Você poderá retomar o envio a qualquer momento na tela de <b>Solicitações de Pedidos</b>.
                            </span>
                          </b-alert>
                        </template>
                        <b-row>
                          <b-col><h2 class="mt-3">Solicitação de protesto</h2></b-col>
                        </b-row>
                        <!-- CONFERENCIA DADOS - Dados do Apresentante -->
                        <b-row>
                          <b-col><hr><h5 class="mt-2">Dados do Apresentante</h5></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <label><b>Nome: </b>{{form.nome_apresentante}}</label>
                          </b-col>
                          <b-col md="6">
                            <label><b>Documento: </b>{{form.documento_apresentante}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <label><b>Email: </b>{{form.email_apresentante}}</label>
                          </b-col>
                          <b-col md="6">
                            <label><b>Celular: </b>{{form.celular_apresentante}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <label><b>Endereço: </b>{{form.endereco_apresentante.endereco}}</label>
                          </b-col>
                          <b-col md="6">
                            <label><b> UF: </b> {{form.endereco_apresentante.uf}}</label>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col md="6">
                            <label><b>Cidade: </b> {{form.endereco_apresentante.cidade}}</label>
                          </b-col>
                          <b-col md="6">
                            <label><b>CEP: </b>{{form.endereco_apresentante.cep}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6">
                              <label><b>Bairro: </b> {{form.endereco_apresentante.bairro}}</label>
                            </b-col>
                        </b-row>
                        <!-- CONFERENCIA DADOS - Dados do Sacador -->
                        <b-row><b-col><hr><h5 class="mt-2">{{form.dados_divida.especie.code === 'CH' ? 'Endossante' : 'Dados do Sacador'}}</h5></b-col></b-row>
                        <b-row>
                          <b-col md="6"><label><b>Nome: </b>{{ dadosSacador.nome }}</label></b-col>
                          <b-col md="6"><label ><b>Documento: </b>{{ dadosSacador.documento }}</label></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6"><label><b>Email: </b>{{ dadosSacador.email }}</label></b-col>
                          <b-col md="6"><label><b>Celular: </b>{{ dadosSacador.celular }}</label></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6"><label><b>Endereço: </b>{{ dadosSacador.endereco.endereco }}</label></b-col>
                          <b-col md="6"><label><b> UF: </b>{{ dadosSacador.endereco.uf }}</label></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6"><label><b>Cidade: </b> {{ dadosSacador.endereco.cidade }}</label></b-col>
                          <b-col md="6"><label><b>CEP: </b>{{ dadosSacador.cep }}</label></b-col>
                        </b-row>
                        <b-row><b-col md="6"><label><b>Bairro: </b>{{ dadosSacador.endereco.bairro }}</label></b-col></b-row>
                        <!-- CONFERENCIA DADOS - Dados do Cedente -->
                        <b-row><b-col><hr><h5 class="mt-2">{{form.dados_divida.especie.code === 'CH' ? 'Endossatário' : 'Dados do Cedente'}}</h5></b-col></b-row>
                        <b-row>
                          <b-col md="6"><label><b>Nome: </b>{{ dadosCedente.nome }}</label></b-col>
                          <b-col md="6"><label ><b>Documento: </b>{{ dadosCedente.documento }}</label></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6"><label><b>Endereço: </b>{{ dadosCedente.endereco.endereco }}</label></b-col>
                          <b-col md="6"><label><b> UF: </b>{{ dadosCedente.endereco.uf }}</label></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6"><label><b>Cidade: </b> {{ dadosCedente.endereco.cidade }}</label></b-col>
                          <b-col md="6"><label><b>CEP: </b>{{ dadosCedente.cep }}</label></b-col>
                        </b-row>
                        <b-row><b-col md="6"><label><b>Bairro: </b>{{ dadosCedente.endereco.bairro }}</label></b-col></b-row>



                        <b-row>
                          <b-col cols="12" md="6">
                            <label><b>Cidade: </b>{{[1,2].includes(form.dados_divida.endosso_selecionada.value)  ? form.endereco_sacador.cidade : form.endereco_cedente.cidade}}</label>
                          </b-col>
                          <b-col md="6">
                            <label><b>CEP: </b>{{[1,2].includes(form.dados_divida.endosso_selecionada.value)  ? sacador_cep : cedente_cep}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6">
                              <label><b>Bairro: </b>{{[1,2].includes(form.dados_divida.endosso_selecionada.value)  ? form.endereco_sacador.bairro : form.endereco_cedente.bairro}}</label>
                            </b-col>
                        </b-row>
                        <!-- CONFERENCIA DADOS - Dados do Devedor -->
                        <b-row>
                          <b-col><hr><h5 class="mt-2">{{form.dados_divida.especie.code === 'CH' ? 'Emitente' : 'Dados do Devedor'}}</h5></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <label><b>Nome: </b>{{form.nome_devedor}}</label>
                          </b-col>
                          <b-col md="6">
                            <label ><b>Documento: </b>{{form.documento_devedor}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="6">
                            <label><b>Email: </b>{{form.email_devedor}}</label>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label><b>Contato: </b>{{form.celular_devedor}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <label><b>Endereço: </b>{{form.endereco_devedor.endereco}}</label>
                          </b-col>
                          <b-col md="6">
                            <label><b>UF: </b>{{form.endereco_devedor.uf}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="6">
                            <label><b>Cidade: </b>{{form.endereco_devedor.cidade}}</label>
                          </b-col>
                          <b-col cols="12" md="6" lg="3">
                            <label><b>CEP: </b>{{devedor_cep}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6">
                              <label><b>Bairro: </b>{{form.endereco_devedor.bairro}}</label>
                            </b-col>
                        </b-row>
                        <!-- CONFERENCIA DADOS - Dados dos Codevedores -->
                        <template v-if="aCodevedor && aCodevedor.length > 0">
                          <b-row v-for="(codevedor, index) in aCodevedor" :key="index">
                            <b-col><hr><h5 class="mt-2">{{form.dados_divida.especie.code === 'CH' ? 'Emitente' : 'Dados do Devedor'}} {{ index + 2 }}</h5></b-col>
                            <b-col md="6">
                              <label><b>Nome: </b>{{ codevedor.nm_nome }}</label>
                            </b-col>
                            <b-col md="6">
                              <label ><b>Documento: </b>{{ codevedor.nm_nr_documento }}</label>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label><b>Email: </b>{{codevedor.email_devedor}}</label>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label><b>Contato: </b>{{codevedor.celular_devedor}}</label>
                            </b-col>
                            <b-col md="6">
                              <label><b>Endereço: </b>{{codevedor.endereco_devedor.nm_endereco_devedor}}</label>
                            </b-col>
                            <b-col md="6">
                              <label><b>UF: </b>{{codevedor.endereco_devedor.sg_uf_devedor}}</label>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label><b>Cidade: </b>{{codevedor.endereco_devedor.nm_cidade_devedor}}</label>
                            </b-col>
                            <b-col cols="12" md="6" lg="3">
                              <label><b>CEP: </b>{{codevedor.endereco_devedor.nm_nr_cep_devedor}}</label>
                            </b-col>
                            <b-col cols="12" md="6">
                              <label><b>Bairro: </b>{{codevedor.endereco_devedor.nm_bairro_devedor}}</label>
                            </b-col>
                          </b-row>
                        </template>
                        <!-- CONFERENCIA DADOS - Informações da dívida -->
                        <b-row>
                          <b-col><hr><h5 class="mt-2">{{form.dados_divida.especie.code === 'CH' ? 'Dados do Cheque' : 'Informações da dívida'}}</h5></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <label><b>Numero:</b> {{form.dados_divida.numero}}</label>
                          </b-col>
                          <b-col md="6">
                            <label ><b>Data emissão:</b> {{form.dados_divida.dt_emissao.substring(8,10)+'/'+form.dados_divida.dt_emissao.substring(5,7) +'/'+form.dados_divida.dt_emissao.substring(0,4)}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="6">
                            <label><b>Nosso número:</b> {{form.dados_divida.numero}}</label>
                          </b-col>
                          <b-col cols="12" md="6">
                            <label><b>Data vencimento:</b> {{form.dados_divida.dt_vencimento.substring(8,10)+'/'+form.dados_divida.dt_vencimento.substring(5,7)+'/'+form.dados_divida.dt_vencimento.substring(0,4)}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="9" lg="6">
                            <label><b>Espécie:</b> {{form.dados_divida.especie.label}}</label>
                          </b-col>
                          <b-col cols="12" md="3" lg="6">
                            <label><b>{{form.dados_divida.especie.code === 'CH' ? 'Valor do cheque:' : 'Valor do título:'}}</b> {{form.dados_divida.valor}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="6">
                            <label><b>Endosso:</b> {{form.dados_divida.endosso_selecionada.label}}</label>
                          </b-col>
                          <b-col cols="12" md="3" lg="6">
                            <label><b>Valor a protestar:</b> {{form.dados_divida.saldo}}</label>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" md="6">
                            <template v-if="(form.dados_divida.aceite === '1')">
                              <label><b>Aceite:</b>  Sim</label>
                            </template>
                            <template v-if="(form.dados_divida.aceite === '2')">
                              <label><b>Aceite:</b>  Não</label>
                            </template>
                            <template v-if="(form.dados_divida.aceite === '3')">
                              <label><b>Aceite:</b>  Sem aceite</label>
                            </template>
                          </b-col>
                          <b-col cols="12" md="3" lg="6" v-if="form.np_cd_ibge && ['NP','NPR','CH','CTI'].includes(form.dados_divida.especie.code)">
                            <label><b>Praça de Protesto:</b> {{form.np_cd_ibge.label + ' / ' + form.np_sg_uf}}</label>
                          </b-col>
                        </b-row>
                        <b-row><b-col cols="12" md="5"><label><b>Fins falimentares:</b> {{tipo_protesto.text === 'FINS_FALIMENTARES' ? 'Sim' : 'Não'}}</label></b-col></b-row>
                      </b-card-text>
                    </b-card>
                    <!-- FIM CARDS CONFERE DADOS -->
                    <br>
                    <b-row class="col-12 mb-3 pl-4">
                      <b-form-checkbox id="aceite-declaracao" v-model="aceiteDeclaracao" name="aceite-declaracao" class="col-12 float-right">
                        * Declaro, sob as penas da Lei, que garanto a origem e integridade do documento digitalizado, bem como que a
                          dívida foi regularmente constituída e que os documentos originais ou suas cópias autenticadas, comprobatórios da
                          causa do título ou do documento de dívida que ensejou a apresentação para protesto, são mantidos em meu poder,
                          comprometendo-me a exibi-los sempre que exigidos, no lugar e data onde me for determinado, especialmente se
                          sobrevier sustação judicial de protesto.
                        </b-form-checkbox>
                    </b-row>
                  </b-tab>
                  <!-- FIM STEP 4 - Confirmação de dados -->
                </b-tabs>
                <b-row>
                  <b-col>
                    <template v-if="currentTab.buttons.next">
                      <b-button :variant="currentTab.buttons.next.variant" class="float-right mt-2" :disabled="disableNextButton" @click="nextStep(currentTab.buttons.next.action)">
                        {{ this.currentTab.buttons.next.title }}
                      </b-button>
                    </template>
                    <template v-if="currentTab.buttons.back">
                      <b-button :variant="currentTab.buttons.back.variant" class="float-right mt-2 mr-4" @click="backStep(currentTab.buttons.back.action)">
                        {{ this.currentTab.buttons.back.title }}
                      </b-button>
                    </template>
                  </b-col>
                </b-row>
              </b-form>
            </template>
            <!-- FIM FORM / FORMPROCURACAO -->
            <!-- ANEXO DOCUMENTO -->
            <!-- CARD ANEXO ID#anexo -->
            <template v-if="ic_protesto_solicitado && form.ic_anexo_documento">
              <b-card id="card_anexo" border-variant="primary-ieptb" header-text-variant="primary-ieptb" color="red" class="card-ieptb">
                <template v-slot:header>Anexo de documentos</template>
                <b-card-text class="card_anexo">
                  <!-- CONDICIONAL - CAMPO:anexo - Sucesso ao processar pedido -->
                  <template v-if="cd_pedido_protesto">
                    <div class="my-4 text-center">
                      <b-icon icon="check-circle-fill" variant="success" font-scale="4"></b-icon>
                      <h2 class="mt-3">Pedido Requisitado com Sucesso!</h2>
                      <p class="text-muted">Solicitação de Protesto nº <strong>{{ cd_pedido_protesto }}</strong></p>
                    </div>
                    <hr class="my-4">
                    <div>
                      <h4 class="h5 mb-3">
                        <span class="badge badge-primary mr-2">Próximo Passo</span>
                        Anexar Documentação
                      </h4>

                      <b-alert show variant="warning" class="border-0 shadow-sm">
                        <p class="mb-2"><strong>Atenção:</strong> Para que este protesto tenha prosseguimento, é necessário o envio de anexo.</p>
                        <p>
                          Se você não conseguir anexar agora, o pedido ficará <strong>pendente</strong>.
                          Você poderá retomar o envio a qualquer momento na tela de <b>Solicitações de Pedidos</b>.
                        </p>
                      </b-alert>
                      <b-button :disabled="loading" class="upload-anexo float-right" variant="info" @click="openUploadDocumentosModal"><font-awesome-icon size="1x" class="mr-2" icon="upload"/>Enviar Anexo</b-button>
                    </div>
                    <ModalUploadDocumentos
                        modal-id="upload-modal"
                        title="Upload de Documentos"
                        :accepted-types="'.pdf, .xls, .xlsx, .p7s, .zip'"
                        :max-file-size="5300000"
                        :max-files="1"
                        :allow-multiple="false"
                        @files-selected="handleFilesSelected"
                    />
                  </template>
                  <!-- FIM CONDICIONAL - CAMPO:anexo - Sucesso ao processar pedido -->
                  <!-- CONDICIONAL - CAMPO:anexo - Erro ao processar pedido -->
                  <template v-else>
                    <div class="my-4 text-center">
                      <b-icon icon="x-circle-fill" variant="danger" font-scale="4"></b-icon>
                      <h2 class="mt-3">Falha ao Requisitar Pedido!</h2>
                      <hr class="my-4">
                      <h5 class="p-5">Ocorreu um erro inesperado ao processar o pedido de protesto, verifique na lista de solicitações ou contate o suporte para mais detalhes.</h5>
                    </div>
                  </template>
                  <!-- FIM CONDICIONAL - CAMPO:anexo - Erro ao processar pedido -->
                </b-card-text>
              </b-card>
            </template>
            <!-- FIM ANEXO DOCUMENTO -->
          </b-container>
        </b-col>
        <!-- FIM CORPO -->
      </b-row>
    </div>
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import Header from "../../components/Header";
import API from "../../services/api";
import Menu from "../../template/Menu";
import Serv from "../../services";
import axios from "axios";
import Modal from "../../components/modal/Confmodal";
import codevedor from "../../components/codevedor/codevedor_component.vue";
import pdfx from "vue-pdf";
import footersite from "@/components/footersite";
import footersitemobile from "@/components/footersite/index_mobile";
import ModalUploadDocumentos from "@/components/documentos/modal_upload_documentos/ModalUploadDocumentos.vue";
import DialogComponent from "@/components/modal/dialog.component.vue";
import {
  isDocumentoCNPJ,
  isDocumentoCPF,
  limpaDocumento,
  validateDocumento
} from '@/utils/validators/Documento';
import {validateEmail} from '@/utils/validators/Email';
import {
  formataTelefone,
  formataDocumento,
  formataCEP,
  formataEndereco,
  formataMoeda
} from '@/utils/formatters/Formatter';


// import especies from "../../services/especies_febabran_v43";
//import Modal from '../../components/modal/Confmodal'

export default {
  components: {
    ModalUploadDocumentos,
    Header,
    Menu,
    Modal,
    pdfx,
    codevedor,
    footersite,
    footersitemobile,
    DialogComponent
    //Modal,
  },
  data() {
    return {
      desabilita_anexo:false,
      // Lista de especies  que precisam de aceite
      listAceiteDeclaracao: ['DSI', 'DMI','DM', 'LC', 'CAC', 'CAF', 'CAM', 'CI', 'CAR', 'CRC', 'CF', 'CFA', 'CFB', 'CL', 'CLC', 'CM', 'CTI', 'CT', 'CD', 'NP'],
      breadCrumb:[
        {text: 'Painel',href: "/painel" },
        {text: 'Protesto',disabled: true},
        {text: 'Novo Pedido',active: true}
      ],
      tituloEspecies: {},
      aceiteDeclaracao:false,
      tabs:[
        {index:0, title: 'Dívida', key: 'DADOS_DIVIDA', buttons:{next: {title:'Prosseguir', action:'NEXT', variant:'primary'}}},
        {index:1, title: 'Dados Credor', key: 'DADOS_CREDOR',buttons:{next: {title:'Prosseguir', action:'NEXT', variant:'primary'},back: {title:'Voltar', action:'BACK', variant:'secondary'}}},
        {index:2, title: 'Dados Devedor', key:'DADOS_DEVEDOR',buttons:{next: {title:'Prosseguir', action:'NEXT', variant:'primary'},back: {title:'Voltar', action:'BACK', variant:'secondary'}}},
        {index:3, title: 'Anexo Consentimento', key:'ANEXO_CONSENTIMENTO',buttons:{next: {title:'Conferir Informações', action:'VALIDAR', variant:'primary'},back: {title:'Voltar', action:'BACK', variant:'secondary'}}},
        {index:4, title: 'Conferir Informações', key:'CONFERIR_DADOS',buttons:{next: {title:'Solicitar Protesto', action:'SOLICITAR', variant:'success'},back: {title:'Corrigir Dados', action:'CORRIGIR', variant:'danger'}}},
        {index:5, title: 'Anexar Documento', key:'ANEXAR_DOCUMENTO',buttons:{}},
      ],
      tabIndex: 0,
      validado:false,
      desabilidar:false,
      arquivosCertidao: [],
      loading: false,
      show: true,
      procuracao: {},
      termoAceite: "",
      logged: "",
      solicitarProtesto:false,
      bloqueio9430:false,
      erroAnexoSP:false,
      erroEspecieAM:false,
      aCodevedor:[],
      codevedoresKey:0,
      id_codevedor_excluido:0,
      ds_endereco_boleto: null,
      totalCodevedor:0,
      numPages:0,
      aNP:[],
      cidades:[],
      estadosService:[],
      travaCedente:false,
      tipo_protesto: {},
      tipos_protesto:[
        {
          value: "0",
          text: "COMUM",
          label: "Comum"
        },
        // CONDICIONAL: CREDOR PJ - documento_sacador
        // {
        //   value: "1",
        //   text: "Fins Fiscais",
        // },
        // CONDICIONAL: DEVEDOR PJ - documento_devedor
        // {
        //   value: "2",
        //   text: "Fins Falimentares",
        // }
      ],
      servico_protesto:null,
      cd_pedido_protesto:null,
      ic_protesto_solicitado: false,
      form: {
        file: [],
        ic_anexo_documento: false,
        nome_apresentante: "",
        documento_apresentante: "",
        email_apresentante: "",
        celular_apresentante: "",
        endereco_apresentante: {
          cep: "",
          endereco: "",
          cidade: "",
          cd_uf: "",
          uf: "",
          uf_selecionada: {},
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          bairro: "",
        },
        documento_solicitante: "",
        nome_sacador: "",
        documento_sacador: "",
        email_sacador: "",
        celular_sacador: "",
        endereco_sacador: {
          cep: "",
          endereco: "",
          cidade: "",
          cd_uf: "",
          uf: "",
          uf_selecionada: {},
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          bairro: "",
        },
        nome_devedor: "",
        documento_devedor: "",
        endereco_devedor: {
          cep: "",
          endereco: "",
          cidade: "",
          cd_uf: "",
          uf: "",
          uf_selecionada: {},
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          bairro: "",
        },
        nome_cedente: "",
        documento_cedente: "",
        endereco_cedente: {
          cep: "",
          endereco: "",
          cidade: "",
          cd_uf: "",
          uf: "",
          uf_selecionada: {},
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          bairro: "",
        },
        np_cd_uf_selecionada:{},
        np_cd_uf:'',
        np_sg_uf:'',
        np_cd_ibge_selecionada:{},
        np_cd_ibge:'',
        dados_divida: {
          numero: "",
          nosso_numero: "",
          especie: "",
          justificativa_cheque: "",
          endosso_selecionada: { value: "3", text: "Sem Endosso", label: "Sem Endosso" },
          endosso: "3",
          aceite_selecionada: { value: "2", text: "Não", label: "Não" },
          aceite: "2",
          finsFalimentares: "2",
          declaracao_portador: "C",
          saldo: "",
          valor: "",
          dt_emissao: "",
          dt_vencimento: "",
        },
        ic_finalidade_pedido: 0,
        //anexo:'',
      },
      message: "",
      progress: "",
      reader: "",
      servicosEletronicos: [], // Must be an array reference!
      options: [],
      erro: "",
      erroPushRoute:{name:'painel'},
      erroPushMsg:'',
      modalShow: false,
      newWindow: "",
      cd_procuracao: "",
      cdibgeselecionado: "",
      cartorioSelecionado: "",
      municipiosNP:[],
      estados: [],
      municipios: [],
      cartorios: [],
      especies: [],
      endosso: [
        {value: "1",text: "Mandato",label: "Mandato"},
        {value: "2",text: "Translativo",label: "Translativo"},
        {value: "3",text: "Sem Endosso",label: "Sem Endosso"},
      ],
      aceite: [
        {value: "1",text: "Sim",label: "Sim"},
        {value: "2",text: "Não",label: "Não"},
        {value: "3",text: "Sem Aceite",label: "Sem Aceite"},
      ],
      finsFalimentares: [
        {value: "1",text: "Sim",label: "Sim"},
        {value: "2",text: "Não",label: "Não"},
      ],
      declaracoes_portador: [
        {value: "C",text: "Por indicação",label: "Por indicação"},
      ],
      optionalValidations:{
        email_devedor:null,
      },
      validations: {

        nome_cedente: null,
        documento_cedente: null,
        endereco_cedente_cep: null,
        endereco_cedente_endereco: null,
        endereco_cedente_logradouro: null,
        endereco_cedente_numero: null,
        endereco_cedente_cidade: null,
        endereco_cedente_bairro: null,
        endereco_cedente_uf: null,

        nome_sacador: null,
        documento_sacador: null,
        email_sacador: null,
        celular_sacador: null,
        endereco_sacador_cep: null,
        endereco_sacador_endereco: null,
        endereco_sacador_logradouro: null,
        endereco_sacador_numero: null,
        endereco_sacador_cidade: null,
        endereco_sacador_bairro: null,
        endereco_sacador_uf: null,

        nome_devedor: null,
        documento_devedor: null,
        endereco_devedor_cep: null,
        endereco_devedor_endereco: null,
        endereco_devedor_logradouro: null,
        endereco_devedor_numero: null,
        endereco_devedor_cidade: null,
        endereco_devedor_bairro: null,
        endereco_devedor_uf: true,

        dados_divida_numero: null,
        dados_divida_nosso_numero: null,
        dados_divida_dt_emissao: null,
        dados_divida_dt_vencimento: null,
        dados_divida_especie: true,
        dados_divida_endosso: null,
        dados_divida_aceite: null,
        dados_divida_fins_falimentares: null,
        dados_divida_valor: null,
        dados_divida_saldo: null,
        dados_divida_anexo: null,
        np_cd_uf:null,
        np_cd_ibge: null,
      },

      sacador_cep: "",
      cedente_cep: "",
      sacador_cep_inicial: "",
      devedor_cep: "",
      erroAnexo: "",
      confirmado: false,
      confirmadoCustas: false,
      maxDate: "",
      minDate: "",
      devedor_uf: "",
      endereco_sacador_cidade_disabled: false,
      endereco_sacador_uf_disabled: false,
      endereco_devedor_cidade_disabled: false,
      endereco_devedor_uf_disabled: false,
      arquivosPermitidos: [
        "application/zip",
        "application/x-zip-compressed",
        "application/pkcs7-signature",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/pdf",
      ],
      primeiroSelectCTIMunicipio:true,
      anexoObrigatorioProcuracao: ['DMI','DSI'],
      especiesSemAnexo: ['DMI','DSI', 'CBI'],
      especiesTravaSP: ['CH', 'EC', 'LC', 'RA', 'NP'],
    };
  },
  computed: {
    /*/////////////////////////////////////////*/
    /*/// REGRAS OK - AVALIAR REGRAS ABAIXO ///*/
    /*/////////////////////////////////////////*/
    especieCTIMunicipioDivergente(){
      if(this.form.dados_divida.especie.code === 'CTI'){
        if(this.form.endereco_devedor.cd_uf !== this.form.np_cd_uf) return true;
        else return (this.form.endereco_devedor.cidade !== this.form.np_cd_ibge_selecionada.text);
      }
      else return false;
    },
    disableNextButton() {
      if(this.currentTab.buttons.next.action === 'VALIDAR' && !this.formValido) return true;
      return (this.currentTab.buttons.next.action === 'SOLICITAR' && (!this.formValido || !this.aceiteDeclaracao));
    },
    isValidationsValid() {
      const invalidKeys = Object.keys(this.validations).filter(key => this.validations[key] === false);

      if (invalidKeys.length > 0) {
        console.log("Main Validations Failed:", invalidKeys);
      }
      return Object.values(this.validations).every(v => v !== false)
    },
    isCodevedoresValid() {
      this.aCodevedor.forEach((devedor, index) => {
        const invalidStates = Object.keys(devedor.state).filter(key => devedor.state[key] === false);

        if (invalidStates.length > 0) {
          console.log(`Codevedor [${index}] Failed:`, invalidStates);
        }
      });
      return this.aCodevedor.every(c => Object.values(c.state).every(s => s !== false))
    },
    isTravaSP(){
      return (this.especiesTravaSP.indexOf(this.form.dados_divida.especie.code) >= 0 &&
          ((this.form.np_cd_uf  === '35') ||
              (this.form.np_cd_uf == null && this.form.endereco_devedor.cd_uf === '35') ));
    },
    formValido(){
      return this.isValidationsValid && this.isCodevedoresValid && !this.isTravaSP;
    },
    regraAnexo() {
      // 24/10/2025 - Validação de Procuração para DMI/DSI: PF Solicitante + PJ Sacadora [anexoObrigatorioProcuracao]
      let docSolicitante = this.form.documento_apresentante;
      let docSacador = this.form.documento_sacador;
      let especie = this.form.dados_divida.especie.code;
      if(this.anexoObrigatorioProcuracao.indexOf(especie) >= 0 && (docSolicitante !== docSacador)) {
        return 'LIVRE' //'OBRIGATORIO' -- ANEXO NAO MAIS OBRIGATORIO PARA ESSES CASOS POREM PERMITIDO
      }
      if(this.especiesSemAnexo.indexOf(especie) >= 0) {
        return "PROIBIDO"
      }
      return "LIVRE"
    },
    currentTab() {
      return this.tabs.find(tab => tab.index === this.tabIndex);
    },
    dadosSacador() {
      // CEDENTE == CREDOR ORIGINAL
      const isCedenteCredorOriginal = this.form.dados_divida.endosso_selecionada && ['3', 3].includes(this.form.dados_divida.endosso_selecionada.value);
      return isCedenteCredorOriginal ? {
        nome: this.form.nome_cedente,
        documento: this.form.documento_cedente,
        email: this.form.email_cedente,
        celular: this.form.celular_cedente,
        endereco: this.form.endereco_cedente,
        cep: this.cedente_cep
      } : {
        nome: this.form.nome_sacador,
        documento: this.form.documento_sacador,
        email: this.form.email_sacador,
        celular: this.form.celular_sacador,
        endereco: this.form.endereco_sacador,
        cep: this.sacador_cep
      }
    },
    dadosCedente() {
      // CEDENTE != CREDOR ORIGINAL
      const hasCredorOriginal = this.form.dados_divida.endosso_selecionada && [1,2].includes(this.form.dados_divida.endosso_selecionada.value)
      return hasCredorOriginal ? {
        nome: this.form.nome_sacador,
        documento: this.form.documento_sacador,
        email: this.form.email_sacador,
        celular: this.form.celular_sacador,
        endereco: this.form.endereco_sacador,
        cep: this.sacador_cep
      } : {
        nome: this.form.nome_cedente,
        documento: this.form.documento_cedente,
        email: this.form.email_cedente,
        celular: this.form.celular_cedente,
        endereco: this.form.endereco_cedente,
        cep: this.cedente_cep
      }
    },
    /*/////////////////////////////////////////*/
    /*/// REGRAS OK - AVALIAR REGRAS ABAIXO ///*/
    /*/////////////////////////////////////////*/
  },
  watch: {
    /*/////////////////////////////////////////*/
    /*/// REGRAS OK - AVALIAR REGRAS ABAIXO ///*/
    /*/////////////////////////////////////////*/
    regraAnexo(val){
      if(val === 'OBRIGATORIO') this.form.ic_anexo_documento = true;
      if(val === 'PROIBIDO') this.form.ic_anexo_documento = false;
    },
    'form.documento_sacador':function (val){
      if(!val) return
      if(isDocumentoCNPJ(val)) this.tipos_protesto.push({value: "1",text: "FINS_FISCAIS",label: "Fins Fiscais"});
      else {
        let index = this.tipos_protesto.findIndex(x => x.text === "FINS_FISCAIS");
        if (index !== -1) this.tipos_protesto.splice(index, 1);
        this.tipo_protesto = this.tipos_protesto.find(x => x.text === "COMUM");
      }
    },
    'form.documento_devedor':function (val){
      if(!isDocumentoCNPJ(val)) return
      if(val) this.tipos_protesto.push({value: "2",text: "FINS_FALIMENTARES",label: "Fins Falimentares"});
      else {
        let index = this.tipos_protesto.findIndex(x => x.text === "FINS_FALIMENTARES");
        if (index !== -1) this.tipos_protesto.splice(index, 1);
        this.tipo_protesto = this.tipos_protesto.find(x => x.text === "COMUM");
      }
    },
    tipo_protesto:function(tipo_selecionado){
      let tipo = tipo_selecionado.text;
      switch (tipo) {
        // TIPO DE PROTESTO: COMUM
        case 'COMUM':
          this.form.ic_finalidade_pedido = 0;
          this.form.dados_divida.finsFalimentares = 0;
          break;
        // TIPO DE PROTESTO: FINS FISCAIS (LEI 9430)
        case 'FINS_FISCAIS':
          this.form.ic_finalidade_pedido = 1;
          this.form.dados_divida.finsFalimentares = 0;
          this.$refs.dialog.open(`Protesto solicitados para Fins do Art. 9A da Lei 9430/96, com PAGAMENTO ANTECIPADO DAS CUSTAS AO CARTORIO, deseja continuar ? <p><br> Se você for pessoa jurídica tributada com base no lucro real, e desejar registrar como perda este crédito, conforme o art. 9º-A da Lei 9.430/96, selecione esta opção.</p> <br><p>Essa ação irá atualizar o campo <b>Fins Falimentares</b> para o valor <b>Não</b></p>`, {
            title: 'Art. 9A da Lei 9430/96',
            okText: 'Continuar',
            cancelText: 'Corrigir Dados'
          }).then(resp => {
            console.log(resp);
            this.confirmadoCustas = true;
          });

          this.form.dados_divida.finsFalimentares = 2
          break;
        // TIPO DE PROTESTO: FINS FALIMENTARES
        case 'FINS_FALIMENTARES':
          this.form.ic_finalidade_pedido = 0;
          this.form.dados_divida.finsFalimentares = 1;
          break;
      }
    },
    'form.np_cd_uf_selecionada': function(val, oldUF) {
      if(!val || !val.value) return;
      this.form.np_cd_uf = val.value;

      // RESETA CIDADE NP
      if(oldUF !== val && this.form.np_cd_ibge !== '') {
        this.form.np_cd_ibge_selecionada = {};
        this.form.np_cd_ibge = '';
      }
      this.aNP.cd_uf = val.value;
      this.form.np_sg_uf = val.text
      if(val.value === '35') {
        let mensagem = 'Conforme Código de Normas de Serviço da CGSP, cheques e notas promissórias e obrigatório a apresentação do documento de dívida fisicamente no cartório';
        this.$refs.dialog.open(mensagem, {title: 'Alerta!',okText: 'Confirmar',showCancel: false});
        this.erroAnexoSP = true;
      }
      else this.erroAnexoSP = false;
      this.buscaCidades(val.value);
    },
    // Valida Divergencia Municipio NP quando Espeice == CTI
    'form.np_cd_ibge_selecionada': function(val){
      if(!val || !val.value) return;
      this.form.np_cd_ibge = val.value;

      this.aNP.cd_ibge = val.value;
    },
    'form.endereco_sacador.uf_selecionada': function(val) {
      if(!val || !val.value) return;
      this.form.endereco_sacador.cd_uf = val.value;
      this.form.endereco_sacador.uf = val.text;
    },
    'form.endereco_cedente.uf_selecionada': function(val) {
      if(!val || !val.value) return;
      this.form.endereco_cedente.cd_uf = val.value;
      this.form.endereco_cedente.uf = val.text;
      this.form.endereco_cedente.cep = this.cedente_cep;
    },
    'form.endereco_devedor.uf_selecionada': function(val, oldVal) {
      if(!val || !val.value) return;
      this.form.endereco_devedor.cd_uf = val.value;
      this.form.endereco_devedor.uf = val.text;
      this.form.endereco_devedor.cep = this.devedor_cep;
      // INICIA CAMPOS NP (UF + IBGE) QUANDO ESPECIE CTI && PREENCHE UF DEVEDOR
      if(this.form.dados_divida.especie.code === "CTI" && (!oldVal || Object.keys(oldVal).length === 0)) {
        this.initUFMunicipioNP();
      }
    },
    'form.endereco_devedor.cidade': function (val) {
      this.primeiroSelectCTIMunicipio = (this.form.dados_divida.especie.code == "CTI")
    },
    'form.dados_divida.especie':function(especie){
      if(!especie || !especie.code) return;
      // REGRAS SP
      this.erroAnexoSP = false;
      if(this.form.endereco_devedor.cd_uf === '35' && ['CH','EC','LC','RA'].includes(especie.code)
          || (this.form.np_cd_uf === '35' && ['NP'].includes(especie.code))){
        let mensagem = 'Conforme Código de Normas de Serviço da CGSP, cheques, confissão de dívida e notas promissórias e obrigatório a apresentação do documento de dívida fisicamente no cartório';
        this.erroAnexoSP = true;
        this.$refs.dialog.open(mensagem, {title: 'Espécie',okText: 'Confirmar',showCancel: false});
      }
      // FIM REGRAS SP

      // REGRAS AM
      this.erroEspecieAM = false;
      if(this.form.endereco_devedor.cd_uf == '13' && ['DV'].includes(especie.code)){
        this.$refs.dialog.open("Espécie não permitida.", {title: 'Espécie',okText: 'Confirmar',showCancel: false});
        this.erroEspecieAM = true;
      }
      // FIM REGRAS AM
      // OUTRAS REGRAS
      if (['CH'].includes(especie.code)) {
        this.$refs.dialog.open("Espécie do tipo \"Cheque\" é necessário  anexar frente verso da imagem.", {title: 'Espécie',okText: 'Confirmar',showCancel: false});
      }

      if (['EC','SJ','CJ','CRJ','RJ'].includes(especie.code)) this.bloqueio9430 = true;
      else this.bloqueio9430 = false;

      // INICIA CAMPOS NP_CD_UF E NP_CD_IBGE QUANDO CTI (DIVERGENTE)
      if(['CTI'].includes(especie.code) && this.estados.length > 0 &&
          this.form.np_cd_uf && this.form.np_cd_uf !== '' &&
          this.form.endereco_devedor.cd_uf && this.form.endereco_devedor.cd_uf !== '') this.initUFMunicipioNP();
      // FIM OUTRAS REGRAS

    },
    'form.dados_divida.endosso_selecionada':function(endosso){
      if(!endosso || !endosso.value) return;
      this.form.dados_divida.endosso = endosso.value;
      this.travaCedente = false
      if(['1','2'].includes(endosso.value)) this.cedente_cep = this.sacador_cep
    },
    'form.dados_divida.aceite_selecionada':function(aceite){
      if(!aceite || !aceite.value) return;
      this.form.dados_divida.aceite = aceite.value;
    },
    especieCTIMunicipioDivergente:function(val, oldVal){
      if(val && !oldVal){
        let municipio = this.municipiosNP.find((d) => d.value == this.form.np_cd_ibge);
        if(municipio){
          this.erro =
              'Solicito a apresentação a protesto do contrato anexo, na cidade de ' + municipio.text +
              ' e declaro, ainda, sob as penas da lei que o devedor emitiu declaração expressa e inequívoca para tanto.';
            this.$refs["declaracaoInequivoca"].show();
        }
      }
    },
    /*/////////////////////////////////////////*/
    /*/// REGRAS OK - AVALIAR REGRAS ABAIXO ///*/
    /*/////////////////////////////////////////*/
  },
  mounted() {
    // this.showInstabilidade();
  },
  created: function () {
    if(localStorage.getItem("usrCpf") !== "22055021826") this.$router.push({name: "painel"});
    this.initLoad();
  },
  methods: {
    showInstabilidade(){
      this.$refs['instabilidade'].show();
      let mensagem = `<p>Identificamos uma instabilidade no sistema no sistema de anexo. Isso pode fazer com que pedidos de protesto que exijam anexo apresentem falhas ou sejam retornados pelo cartório. Nossa equipe já está trabalhando na correção para normalizar o serviço o quanto antes.</p>`;
      this.$refs.dialog.open(mensagem, {title: 'INSTABILIDADE',okText: 'Confirmar',showCancel: false});
    },
    /*////////////////////*/
    /*/// FORMATADORES ///*/
    /*////////////////////*/
    formataDocumento,
    formataTelefone,
    formataCEP,
    formataMoeda,
    limpaValorMonetario(valor){ return  valor.replace(/[R$,. ]/g, "") },
    formataEndereco(pessoa){
      this.form['endereco_' + pessoa].endereco = formataEndereco(this.form['endereco_' + pessoa]);
    },
    /*////////////////////*/
    /*/// FORMATADORES ///*/
    /*////////////////////*/
    /*///////////////////*/
    /*/// LOAD STATES ///*/
    /*///////////////////*/
    async initLoad(){
      this.loading = true;
      const token = localStorage.getItem('jwtToken');
      try{
        await Promise.all([
          this.buscaEstados(),
          this.loadEspecies(),
          this.loadDadosBancarios(token),
          this.loadTermoAceite(token),
          this.getPermicaoServico(token),
        ]);
        await this.usuarioLogado(token);

        let now = new Date();

        let dia = now.getDate();
        let mes = now.getMonth();
        let ano = now.getFullYear();

        this.maxDate = ano + "-" + String("00" + (mes + 1)).slice(-2) + "-" + String("00" + (dia - 1)).slice(-2);
        this.minDate = (ano - 30) + "-" + String("00" + (mes + 1)).slice(-2) + "-" + String("00" + (dia - 1)).slice(-2);
        this.loading = false;
      }
      catch(error){
        console.error("Erro ao processar requisicao: ", error);
        if(error.shouldRedirect){
          this.blockForm();
          this.erroPushMsg = 'Erro ao processar requisicao: ' + error.message + '. Tente novamente mais tarde.';
          this.erroPushRoute = { name: 'Painel' };
          this.$refs['erroPush'].show();
        }
      }
    },
    async buscaEstados() {
      try{
        const res = await API.get(`/uf`);
        this.estados = res.data.map(item => ({...item,label: item.text}));
        this.estados.push(
            {value: "35",text: "SP",label: "SP"},
            {value: null,text: "Selecione",label: "Selecione"}
        );
      }
      catch (error) {
        console.error("Erro na API estados: ", error);
        const err = new Error("Estados");
        err.shouldRedirect = true;
        throw err;
      }
    },
    async loadEspecies() {
      try {
        const res = await API.get('/titulo/especies');

        this.especies = res.data.response.map(especie => ({
          code: especie.sg_especie,
          label: `${especie.sg_especie} - ${especie.nm_descricao}`
        }));

        this.tituloEspecies = res.data.response.reduce((obj, item) => {
          obj[item.sg_especie] = item;
          return obj;
        }, {});
      } catch (error) {
        console.error("Erro na API especies: ", error);
        const err = new Error("Especies");
        err.shouldRedirect = true;
        throw err;
      }
    },
    async usuarioLogado(token) {
      try{
        const res = await API.get("/usuario/logado?token=" + token);
        let pessoas = ['apresentante', 'sacador', 'cedente']
        let endereco = ( res.data[0].nm_endereco + " " + res.data[0].nm_nr_endereco + (res.data[0].nm_complemento ? " - " + res.data[0].nm_complemento : "") ).substr(0, 45);
        let uf = this.estados.find( (d) => d.text == res.data[0].nm_uf);
        if (!uf) {
          uf = this.estados.find(d => d.text == "Selecione") || {value: null, text: "Selecione", label: "Selecione"};
        }
        pessoas.forEach((campo) => {
          this[campo + '_cep']                            = this.formataCEP(res.data[0].nm_nr_cep);
          this[campo + '_cep_inicial']                    = this.formataCEP(res.data[0].nm_nr_cep);
          this.form['endereco_' + campo].cep              = this.formataCEP(res.data[0].nm_nr_cep);
          this.form['nome_'       + campo]                = res.data[0].nm_usuario;
          this.form['documento_'  + campo]                = formataDocumento(res.data[0].nm_nr_cpfcnpj)
          this.form['endereco_'   + campo].endereco       = endereco;
          this.form['endereco_'   + campo].logradouro     = res.data[0].nm_endereco.substr(0, 30);
          this.form['endereco_'   + campo].numero         = res.data[0].nm_nr_endereco.substr(0, 5);
          this.form['endereco_'   + campo].complemento    = res.data[0].nm_complemento != null ? res.data[0].nm_complemento.substr(0, 10) : "";
          this.form['email_'      + campo]                = res.data[0].nm_email;
          this.form['celular_'    + campo]                = res.data[0].nm_nr_celular != null ? this.formataTelefone(res.data[0].nm_nr_celular) : "";
          this.form['endereco_'   + campo].uf_selecionada = uf;
          this.form['endereco_'   + campo].cd_uf          = uf.value;
          this.form['endereco_'   + campo].uf             = res.data[0].nm_uf;
          this.form['endereco_'   + campo].cidade         = res.data[0].nm_cidade;
          this.form['endereco_'   + campo].bairro         = res.data[0].nm_bairro;
        })
      }
      catch (error) {
        console.error("Erro na API de Usuarios: ", error);
        const err = new Error("Usuario");
        err.shouldRedirect = true;
        throw err;
      }

    },
    async loadTermoAceite(token) {
      try{
        const res = await API.post("/usuario/termoaceite/mensagemusuario", {token: token});
        this.erro = res.data.descricao;
        if (res.data.sucesso === 2) this.$router.push({name: "cadastroUser", params: {dadosLiq: "liquidacao"}});
        if (res.data.sucesso === 0) this.$bvModal.show("modal-conf");
      }
      catch (error) {
        console.error("Erro na API termo aceite: ", error);
        const err = new Error("Termo Aceite");
        err.shouldRedirect = true;
        throw err;
      }
    },
    async loadDadosBancarios(token) {
      try {
        const res = await API.get(`usuario/dadosbancarios?token=${token}`);
        if (res.data === "") {
          this.blockForm();
          this.erroPushMsg = 'Cadastro do usuário incompleto...';
          this.erroPushRoute = { name: 'cadastroUser' };
          this.$refs['erroPush'].show();
          return;
        }
      } catch (error) {
        console.error("Erro na API de dados bancários: ", error);
        const err = new Error("Dados Bancarios");
        err.shouldRedirect = true;
        throw err;
      }
    },
    async getPermicaoServico(token) {
      try {
        const res = await API.post("usuario/getPermicaoServico", { token })
        this.servico_protesto = res.data[0].servico_protesto;

        let loginComCertifiicado =
            localStorage.getItem("sg_tipo_documento") &&
            localStorage.getItem("SSL_CLIENT_S_DN_CN") &&
            localStorage.getItem("nm_tipo_certificado") &&
            localStorage.getItem("SSL_CLIENT_S_DN") &&
            localStorage.getItem("SSL_CLIENT_V_START") &&
            localStorage.getItem("SSL_CLIENT_V_END")

        let govLogin = (localStorage.getItem('pxppwiru9') != undefined && localStorage.getItem('pxppwiru9') != null);
        let allowedGov = (govLogin ? ['2','3'].includes(localStorage.getItem("lhwvzhds3")) : false)
        if (this.servico_protesto == '0' ||
            (!loginComCertifiicado && !govLogin && localStorage.getItem("usrCpf") != "22055021826")) {
          this.$refs["confirmaSemCertificado"].show();
          return false;
        }
        else {
          if(govLogin && !allowedGov){
            this.$refs["confirmaSemCertificado"].show();
            return false;
          }
          else{
            this.$root.isLogged().then(() => {
              this.logged = true;
            }).catch(() => {
              this.logged = false;
              return false;
            });
          }
        }
      } catch (error) {
        console.error("Erro na API de permissoes: ", error);
        const err = new Error("Permissoes");
        err.shouldRedirect = true;
        throw err;
      }
    },
    /*///////////////////*/
    /*/// LOAD STATES ///*/
    /*///////////////////*/
    updateBloqueio9430(bloqueio){
      this.bloqueio9430 = bloqueio;
    },
    showError(errorMessage){
      this.erro = errorMessage;
      this.$refs["erro"].show();
    },
    redirecionaPainel(){
      this.$router.push({
        name: "painel",
      });
    },
    limpaEndereco: function (id) {
      this.$set(this.form[id], "cep", "");
      this.$set(this.form[id], "endereco", "");
      this.$set(this.form[id], "logradouro", "");
      this.$set(this.form[id], "complemento", "");
      this.$set(this.form[id], "numero", "");
      this.$set(this.form[id], "bairro", "");
      this.$set(this.form[id], "cidade", "");
      this.$set(this.form[id], "cd_uf", "");
      this.$set(this.form[id], "uf", "");
      this.$set(this.form[id], "uf_selecionada", {});
      this.validations[id + `_bairro`] = false;
      this.validations[id + `_cidade`] = false;
      this.validations[id + `_endereco`] = false;
      this.validations[id + `_logradouro`] = false;
      this.validations[id + `_numero`] = false;
      this.validations[id + `_uf`] = false;
      this.validations[id + '_cep'] = this.form[id].cep != "" && this.formataCEP(this.form[id].cep).length == 9;
    },
    BuscarCep: function (cep, id) {
      if (cep.length !== 9) return this.limpaEndereco(id);
      if (id === 'endereco_sacador' && this.sacador_cep_inicial === cep) return;
      var cepl = cep.replace("-", "");
      var self = this;
      let uf = id + "_uf_disabled";
      let cidade = id + "_cidade_disabled";
      axios.get(`https://viacep.com.br/ws/${cepl}/json/`)
        .then((resp) => {
          if (resp.data.erro === true || resp.data.erro === "true") {
            this.limpaEndereco(id);
            const token = localStorage.getItem("jwtToken");
            self[uf] = true;
            self[cidade] = true;
            API.get('cran/cep', {
              params: {
                cep: cepl
              },
              token: token
            }).then((resCran) => {
              self.validations[id + `_uf`] = true;
              self.validations[id + `_cidade`] = true;
              let ufSelecionada = self.estados.find((d) => d.text == resCran.data.uf);
              self.$set(self.form[id],"uf_selecionada", ufSelecionada);
              self.$set(self.form[id],"cidade",resCran.data.municipio.substr(0, 20));
              self.$set(self.form[id], "cep", cepl);
              this.validations[id + '_cep'] = this.form[id].cep != "" && this.formataCEP(this.form[id].cep).length == 9;
            }).catch((err) => {
              console.log("Erro inesperado ao Buscar CEP: " + err.message);
              this.limpaEndereco(id);
              self[uf] = false;
              self[cidade] = false;
              self.$set(self.form[id], "cep", cepl);
              this.validations[id + '_cep'] = this.form[id].cep != "" && this.formataCEP(this.form[id].cep).length == 9;
            });
          } else {
            self[uf] = true;
            self[cidade] = true;
            self.validations[id + `_uf`] = true;
            self.validations[id + `_cidade`] = true;
            self.validations[id + `_bairro`] = true;
            self.validations[id + `_logradouro`] = true;
            let ufSelecionada = self.estados.find((d) => d.text == resp.data.uf);
            self.$set(self.form[id], "cep", cepl);
            self.$set(self.form[id], "logradouro", resp.data.logradouro.substr(0,30));
            if(resp.data.bairro.length > 0)
              self.$set(self.form[id],"bairro",resp.data.bairro.substr(0, 20));
            self.$set(self.form[id], "cidade",resp.data.localidade.substr(0, 20));
            self.$set(self.form[id], "uf_selecionada", ufSelecionada);
            self.$set(self.form[id], "ibge", resp.data.ibge);
            this.validations[id + '_cep'] = this.form[id].cep != "" && this.formataCEP(this.form[id].cep).length == 9;
          }
        })
        .catch((error) => {
          console.log("Erro inesperado ao Buscar CEP: " + error);
          this.limpaEndereco(id);
          self[uf] = false;
          self[cidade] = false;
          self.$set(self.form[id], "cep", cepl);
          this.validations[id + '_cep'] = this.form[id].cep != "" && this.formataCEP(this.form[id].cep).length == 9;
        });
    },
    /*//////////////////*/
    /*/// VALIDATORS ///*/
    /*//////////////////*/
    onTouchField(field, event) {
      if(!event) return false;
      // Valida campos endereco
      if(field.startsWith("endereco_")){
        var endereco_pessoa = field.slice(0, field.lastIndexOf('_'));
        var endereco_campo  = field.split('_').pop();
        this.validations[field] = this.form[endereco_pessoa][endereco_campo] != "";
      }
      else{
        switch (field) {
          case 'especie': this.validations.dados_divida_especie = this.form.dados_divida.especie != ""; break;
          case 'numero':  this.validations.dados_divida_numero = this.form.dados_divida.numero != ""; break;
          case 'dt_emissao': this.validations.dados_divida_dt_emissao = this.form.dados_divida.dt_emissao != "" && this.valida_data_emissao(this.form.dados_divida.dt_emissao); break;
          case 'dt_vencimento': this.validations.dados_divida_dt_vencimento = this.form.dados_divida.especie.code === "CJ" ? true : this.form.dados_divida.dt_vencimento !== "" && this.valida_data_vencimento(this.form.dados_divida.dt_vencimento, this.form.dados_divida.dt_emissao); break;
          case 'valor': this.validations.dados_divida_valor = this.limpaValorMonetario(this.form.dados_divida.valor) > 0; break;
          case 'saldo': this.validations.dados_divida_saldo = this.limpaValorMonetario(this.form.dados_divida.saldo) > 0; break;
        }
      }
    },
    validarCampos(){
      this.validations.dados_divida_especie             = this.form.dados_divida.especie != ""
      this.validations.dados_divida_numero              = this.form.dados_divida.numero != ""
      this.validations.dados_divida_dt_emissao          = this.form.dados_divida.dt_emissao != "" && this.valida_data_emissao(this.form.dados_divida.dt_emissao);
      this.validations.dados_divida_dt_vencimento       = this.form.dados_divida.especie.code === "CJ" ? true : this.form.dados_divida.dt_vencimento !== "" && this.valida_data_vencimento(this.form.dados_divida.dt_vencimento, this.form.dados_divida.dt_emissao);

      this.validations.dados_divida_valor               = this.limpaValorMonetario(this.form.dados_divida.valor) > 0
      this.validations.dados_divida_saldo               = this.limpaValorMonetario(this.form.dados_divida.saldo) > 0


      let pessoas = ['apresentante', 'sacador', 'devedor', 'cedente']
      pessoas.forEach((campo) => {
        this.validations['nome_' + campo]                               = this.form['nome_' + campo] != "" && this.form['nome_' + campo].length >= 3
        this.validations['documento_' + campo]                          = validateDocumento(this.form['documento_' + campo])
        this.validations['endereco_' + campo + '_bairro']               = this.form['endereco_' + campo].bairro != ""
        this.validations['endereco_' + campo + '_cep']                  = this.form['endereco_' + campo].cep != "" && this.formataCEP(this.form['endereco_' + campo].cep).length == 9
        this.validations['endereco_' + campo + '_cidade']               = this.form['endereco_' + campo].cidade != ""
        this.validations['endereco_' + campo + '_endereco']             = this.form['endereco_' + campo].endereco != ""
        this.validations['endereco_' + campo + '_logradouro']           = this.form['endereco_' + campo].logradouro != ""
        this.validations['endereco_' + campo + '_numero']               = this.form['endereco_' + campo].numero != ""
        this.validations['endereco_' + campo + '_uf']                   = this.form['endereco_' + campo].uf != ""
      })

      // TODO VALIDACAO EMAIL
      //  /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+$/
      this.aCodevedor.forEach((element, index) => {
        this.aCodevedor[index].state.nome                 = !(element.nm_nome == null || element.nm_nome.length < 3)
        this.aCodevedor[index].state.documento            = !(element.nm_nr_documento == null || element.nm_nr_documento.length < 3)
        this.aCodevedor[index].state.cep                  = !(element.endereco_devedor.nm_nr_cep_devedor == null || element.endereco_devedor.nm_nr_cep_devedor.length < 3)
        this.aCodevedor[index].state.endereco             = !(element.endereco_devedor.nm_endereco_devedor == null || element.endereco_devedor.nm_endereco_devedor.length < 3)
        this.aCodevedor[index].state.endereco_logradouro  = !(element.endereco_devedor.logradouro == null || element.endereco_devedor.logradouro.length < 3)
        this.aCodevedor[index].state.endereco_numero      = !(element.endereco_devedor.numero == null || element.endereco_devedor.numero.length == "")
        this.aCodevedor[index].state.cidade               = !(element.endereco_devedor.nm_cidade_devedor == null || element.endereco_devedor.nm_cidade_devedor.length < 3)
        this.aCodevedor[index].state.bairro               = !(element.endereco_devedor.nm_bairro_devedor == null || element.endereco_devedor.nm_bairro_devedor.length < 3)
        this.aCodevedor[index].state.uf                   = !(element.endereco_devedor.cd_uf === "")
      })

      if(this.especiesTravaSP.indexOf(this.form.dados_divida.especie.code) >= 0 && ((this.form.np_cd_uf  === '35') || (this.form.np_cd_uf == null && this.form.endereco_devedor.cd_uf === '35') )){
        this.erroAnexoSP = true;
      }
    },
    validarEmail: function (validationType, validation, event){
      if(!event) return this[validationType][validation] = true;
      var email = event.target.value;
      return this[validationType][validation] = !(validateEmail(email));
    },
    validarDuplicidadeDocumento(event){
      //validar não permitir que o Documento do Devedor seja igual ao Documento do Sacador ou do Cedente.
      let codevedorDuplicado = this.aCodevedor.filter( d => d.nm_nr_documento == event.target.value);
      if((this.form.documento_sacador != '') &&  (this.form.documento_sacador === this.form.documento_devedor)) {
        let mensagem = 'Documento do Devedor não poder ser igual ao Documento do Sacador ou Cedente'
        this.$refs.dialog.open(mensagem, {title: 'Erro de duplicidade no cadastro!',okText: 'Confirmar',showCancel: false});
        this.$set(this.form, event.target.id, "");
      } else if ((this.form.documento_cedente != '') && (this.form.documento_cedente === this.form.documento_devedor)) {
        let mensagem = 'Documento do Devedor não poder ser igual ao Documento do Sacador ou Cedente'
        this.$refs.dialog.open(mensagem, {title: 'Erro de duplicidade no cadastro!',okText: 'Confirmar',showCancel: false});
        this.$set(this.form, event.target.id, "");
      } else if (codevedorDuplicado.length > 0){
        let mensagem = 'Documento do Devedor não poder ser igual ao Documento do Codevedor'
        this.$refs.dialog.open(mensagem, {title: 'Erro de duplicidade no cadastro!',okText: 'Confirmar',showCancel: false});
        this.$set(this.form, event.target.id, "");
      }
    },
    validarDocumento: function (validationType, validation, event) {
      if(!event) return this[validationType][validation] = true;
      else {
        var documento = limpaDocumento(event.target.value);
        this[validationType][validation] = validateDocumento(documento);
        this.bloqueio9430 = isDocumentoCPF(documento);
      }
      var tipoPessoa = event.target.getAttribute("person")
      this.validarDuplicidadeDocumento(event)
      this.popularPessoa(tipoPessoa, documento)
    },
    //valida campo data_emissao, para não ser maior à hoje nem menor que 30 anos atras
    valida_data_emissao(data_emissao){ return (data_emissao >= this.minDate && data_emissao <= this.maxDate) },
    //valida campo dt_vencimento, para não ser maior ou igual à hoje
    valida_data_vencimento(data_vencimento, data_emissao){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      let dataVencSep = data_vencimento.split("-");
      let dataVencSel = new Date(dataVencSep[0], (dataVencSep[1] - 1), dataVencSep[2]).getTime();
      let dataEmiSep = data_emissao.split("-");
      let dataEmiSel = new Date(dataEmiSep[0], (dataEmiSep[1] - 1), dataEmiSep[2]).getTime();
      return  !(dataVencSel >= new Date(yyyy, (mm - 1), dd).getTime() || dataVencSel < dataEmiSel)
    },
    /*//////////////////*/
    /*/// VALIDATORS ///*/
    /*//////////////////*/
    popularPessoa(tipoPessoa, documento){
      if(isDocumentoCNPJ(documento)) this.consultaDocumentoCNPJ(tipoPessoa, documento);
      else if(tipoPessoa !== '') this.consultaDocumento(tipoPessoa);
    },
    consultaDocumentoCNPJ(tipoPessoa, documento){
      const token = localStorage.getItem("jwtToken");
      API.post('protesto/empresa', {
        token: token,
        documento: documento
      }).then((res) => {
        if (res.data.status === true) {
          const servico = res.data.servico;
          let uf  = this.estados.find((d) => d.text == servico.estado);
          this.form["nome_"     + tipoPessoa]                 = servico.nome;
          this.form["email_"    + tipoPessoa]                 = servico.email;
          this.form["celular_"  + tipoPessoa]                 = servico.contato;
          this.form["endereco_" + tipoPessoa].endereco        = servico.endereco;
          this.form["endereco_" + tipoPessoa].cidade          = servico.cidade;
          this.form["endereco_" + tipoPessoa].cep             = this.formataCEP(servico.cep);
          this.form["endereco_" + tipoPessoa].bairro          = servico.bairro;
          this.form["endereco_" + tipoPessoa].uf_selecionada  = uf;
          this.form["endereco_" + tipoPessoa].sg_uf_devedor   = servico.estado;
          this[tipoPessoa + '_cep']                           = this.formataCEP(servico.cep);
        }
      }).catch((error) => {
        console.error('Erro ao consultar CNPJ:', error);
      });
    },
    consultaDocumento(tipoPessoa){
      const token = localStorage.getItem("jwtToken");
      API.post('protesto/consultaDevedor', {
        token:token,
        documento:this.form['documento_' + tipoPessoa]
      }).then( (res) => {
        if(res.data.dados != null)
        {
          let uf  = this.estados.find((d) => d.text == res.data.dados.sg_uf_devedor);
          this.form['nome_'     + tipoPessoa]                 = res.data.dados.nm_devedor
          this.form['email_'    + tipoPessoa]                 = res.data.dados.nm_email_devedor
          this.form['celular_'  + tipoPessoa]                 = res.data.dados.nm_nr_celular_devedor
          this.form['endereco_' + tipoPessoa].endereco        = res.data.dados.nm_endereco_devedor
          this.form['endereco_' + tipoPessoa].cidade          = res.data.dados.nm_cidade_devedor
          this.form['endereco_' + tipoPessoa].cep             = this.formataCEP(res.data.dados.nm_nr_cep_devedor)
          this.form['endereco_' + tipoPessoa].bairro          = res.data.dados.nm_bairro_devedor
          this.form['endereco_' + tipoPessoa].uf_selecionada  = uf
          this.form['endereco_' + tipoPessoa].sg_uf_devedor   = res.data.dados.sg_uf_devedor
          this.form['endereco_' + tipoPessoa].uf              = res.data.dados.sg_uf_devedor
          this.form['endereco_' + tipoPessoa].cd_uf           = uf.value;
          this[tipoPessoa + '_cep']                           = this.formataCEP(res.data.dados.nm_nr_cep_devedor)
        }
      })
    },
    backStep(action){
      switch (action){
        case 'BACK':
          this.tabIndex--;
          break;
        case 'CORRIGIR':
          this.corrigirFormulario();
          break;
      }
    },
    nextStep(action){
      switch (action){
        case 'NEXT':
          if(this.currentTab.key == 'DADOS_DEVEDOR') this.validarCampos();
          this.tabIndex++;
          break;
        case 'VALIDAR':
          this.validarPedido();
          break;
        case 'SOLICITAR':
          this.gerarPedido();
          break;
      }
    },
    async validarPedido(){
      try{
        if(!this.formValido) return false;
        const token = localStorage.getItem("jwtToken");
        const gIdTk = localStorage.getItem("t178w3gm3");
        const res = await API.post(`protesto/v2/validarPedido`, {
          token: token,
          gIdTk: gIdTk,
          dados: this.form, // form.ic_anexo_documento
          aCodevedor:this.aCodevedor,
          confirmadoCustas: this.confirmadoCustas,
          nm_tipo_certificado: localStorage.getItem("nm_tipo_certificado"),
          SSL_CLIENT_S_DN_CN: localStorage.getItem("SSL_CLIENT_S_DN_CN"),
          SSL_CLIENT_S_DN: localStorage.getItem("SSL_CLIENT_S_DN"),
          SSL_CLIENT_V_START: localStorage.getItem("SSL_CLIENT_V_START"),
          SSL_CLIENT_V_END: localStorage.getItem("SSL_CLIENT_V_END"),
        });
        if(res.data.success){
          this.validado = true;
          this.tabIndex++;
        } else {
          let mensagem = res.data.errors.map(e => e.message).join('\n');
          this.$refs.dialog.open(mensagem, {title: 'Validação dos dados!',okText: 'Confirmar',showCancel: false});
        }
      }
      catch(error){
        console.error("Erro ao processar requisicao: ", error);
        let mensagem = "Erro ao processar requisicao";
        this.$refs.dialog.open(mensagem, {title: 'Validação dos dados!',okText: 'Confirmar',showCancel: false});
      }
    },
    async gerarPedido(){
      if(!this.formValido || !this.aceiteDeclaracao || !this.validado) return false;
      try {
        const token = localStorage.getItem("jwtToken");
        const gIdTk = localStorage.getItem("t178w3gm3");
        const res = await API.post(`protesto/v2/solicitarProtesto`, {
          token: token,
          gIdTk: gIdTk,
          dados: this.form, // form.ic_anexo_documento
          aCodevedor:this.aCodevedor,
          confirmadoCustas: this.confirmadoCustas,
          nm_tipo_certificado: localStorage.getItem("nm_tipo_certificado"),
          SSL_CLIENT_S_DN_CN: localStorage.getItem("SSL_CLIENT_S_DN_CN"),
          SSL_CLIENT_S_DN: localStorage.getItem("SSL_CLIENT_S_DN"),
          SSL_CLIENT_V_START: localStorage.getItem("SSL_CLIENT_V_START"),
          SSL_CLIENT_V_END: localStorage.getItem("SSL_CLIENT_V_END"),
        });
        // SUCESSO - PEDIDO GERADO
        if(res.data.success){
          // ERRO INESPERADO
          if(res.data.warnings != undefined && res.data.warnings.length > 0) {
            let mensagem = res.data.warnings.map(e => e.message).join('\n');
            this.$refs.dialog.open(mensagem, {
              title: 'Erro na geração do pedido!',
              okText: 'OK',
              cancelText: 'Voltar ao Painel'
            }).then(resp => {
              if(resp){
                this.confirmadoCustas = true;
              }
              else this.$router.push({name: "painel"});
            });
          }
          // SEM ERROS
          else {
            var mensagemSucesso = "Solicitação de protesto efetuada.";
            //  COTACAO SP
            if (res.data.uf === "SP") {
              if(res.data.cotacao_sp) mensagemSucesso += ` \nCotação com SP realizada com sucesso.`;
              else mensagemSucesso += ` \nNão foi possível realizar a consulta de cotação com SP. \nPor favor, acesse a lista de pedidos realizados e acione a ação para realizar a cotação com SP.`;
            }
            this.ic_protesto_solicitado = true;
            // PROSSEGUIR PARA ANEXO
            if(this.form.ic_anexo_documento){
              this.cd_pedido_protesto = res.data.cd_pedido_protesto;
              mensagemSucesso += "\n\nProsseguir para anexo?";
              this.$refs.dialog.open(mensagemSucesso, {
                title: 'Pedido gerado',
                okText: 'Prosseguir para anexo',
                cancelText: 'Voltar ao Painel'
              }).then(resp => {
                if(!resp) this.$router.push({name: "painel"});
              });
            }
            // SEM ANEXO - FIM DO FLUXO
            else {
              mensagemSucesso += "\n\nRetornando ao Painel do usuário!";
              this.$refs.dialog.open(mensagemSucesso, {
                title: 'Pedido gerado',
                okText: 'OK',
                cancelText: 'Voltar ao Painel'
              }).then(resp => {
                console.log(resp)
                this.$router.push({name: "painel"});
              });
              setTimeout(() => {this.$router.push({name: "painel"});},2000)
            }
          }
        }
        // ERRO AO GERAR PEDIDO
        else{
          let mensagem = res.data.errors.map(e => e.message).join('\n');
          this.$refs.dialog.open(mensagem, {
            title: 'Erro na geração do pedido!',
            okText: 'Corrigir Formulario',
            cancelText: 'Desistir'
          }).then(resp => {
            if(resp) this.corrigirFormulario();
            else this.$router.push({name: "painel"});
          });
        }
      }
      catch(error){
        console.error("Erro ao processar requisicao: ", error);
        let mensagem = "Erro ao processar requisicao";
        this.$refs.dialog.open(mensagem, {title: 'Validação dos dados!',okText: 'Confirmar',showCancel: false});
      }
    },
    async respConfirm(resposta) {
      this.loading = true;
      if (resposta.respostaFinal == "s") {
        const token = localStorage.getItem("jwtToken");
        const res = await API.get("/usuario/termoaceite/aceite/1?token=" + token);
        this.loading = false;
        if (res.data.status == "error") alert(res.data.msg);
        else this.$router.push({name: "cadastroUser", params: { dadosLiq: "liquidacao"}});
      }
      else this.$router.push({name: "painel"});
    },
    corrigirFormulario: function () {
      this.validado = false;
      this.confirmadoCustas = true;
      this.tabIndex = 0;
    },
    adicionarCodevedor(){
      this.totalCodevedor++;
      let numeroAleatorio = Math.round(Math.random() * 9);
      
      while(!this.verificaExistenciaNumeroAleatorio(numeroAleatorio))numeroAleatorio = Math.floor(Math.random() * 9) + 1;
      let id_codevedor = numeroAleatorio
     
      this.aCodevedor.push({
        id_codevedor: id_codevedor,nm_nome: "",nm_nr_documento: "",
        endereco_devedor: {nm_nr_cep_devedor: "",nm_endereco_devedor: "",nm_cidade_devedor: "",cd_uf: "",sg_uf_devedor: "",nm_bairro_devedor: ""},
        state:{nome:null,documento:null,cep:null,endereco:null,cidade:null,bairro:null,uf:null,email_devedor:null}
      })
    },
    removerCodevedor(res){
      if(res){
        this.id_codevedor_excluido = res.id_codevedor
        this.totalCodevedor--;
        this.codevedoresKey++;
      }
    },
    attCodevedores(res){
      this.aCodevedor = res.codevedores
      this.codevedoresKey++;
    },
    populaEnderecoCodevedor(res){
      console.log(res)
      console.log(this.aCodevedor)
      this.aCodevedor.forEach(codevedor => {
        console.log("ID: " + codevedor.id_codevedor + " - ID2: " + res.id_codevedor)
        if(codevedor.id_codevedor == res.id_codevedor){
          codevedor.endereco_devedor= res.dados;
        }
      });
      this.codevedoresKey++;
      console.log(this.aCodevedor)
    },
    verificaExistenciaNumeroAleatorio(numero){
      return this.aCodevedor.filter( d => d.id_codevedor == numero).length>0 ? false : true;
    },
    async buscaCidades(iduf){
      try{
        this.loading = true;
        const res = await API.get(`/municipios?iduf=` + iduf)
        this.municipiosNP = res.data.map(item => ({...item, label: item.text}));
      }
      catch(error){
        this.$bvToast.toast(`Erro ao inesperado buscar lista de cidades`, {
          title: 'Erro ao buscar cidades!',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center',
          autoHideDelay: 5000,
          solid: true
        })
      }
      finally {
        this.loading = false;
      }
    },
    confirmarMunicipioDeclaracao(resp){
      this.$refs["declaracaoInequivoca"].hide();
      if(!resp) this.initUFMunicipioNP();
    },
    async initUFMunicipioNP(){
      this.setUFNP();
      await this.buscaCidades(this.form.np_cd_uf_selecionada.value);
      this.setMunicipioNP();
    },
    setUFNP(){
      this.form.np_cd_uf_selecionada = this.estados.find((d) => d.value === this.form.endereco_devedor.cd_uf);
    },
    setMunicipioNP(){
      this.loading = true;
      let municipioSelecionado = this.municipiosNP.find((d) => d.text === this.form.endereco_devedor.cidade);
      if(!municipioSelecionado) return
      this.form.np_cd_ibge_selecionada = municipioSelecionado;
      this.form.np_cd_ibge = municipioSelecionado.value;
      this.loading = false;
    },
    isFieldSet(value){
      return (value != undefined && value != '' && value != null)
    },
    confirmaErroPush(){
      this.$router.push(this.erroPushRoute);
      this.$refs['erroPush'].hide();
    },
    blockForm(){
      const form = document.getElementById('frmProcuracao');
      if (form) {
        const elementsToDisable = form.querySelectorAll('input, select, textarea, button, a');
        elementsToDisable.forEach(element => {element.disabled = true;});
      }
    },
    /* FUNCOES MODAL UPLOAD DOCUMENTO */
    openUploadDocumentosModal(){
      if(this.cd_pedido_protesto){
        this.$bvModal.show('upload-modal');
      }
    },
    async handleFilesSelected({ action, files }) {
      if (action !== 'upload' || !files || !files.length) return;

      this.loading = true

      try {
        // Upload de arquivos em paralelo
        if(this.cd_pedido_protesto){
          const results = await Promise.all(
              files.map(file => this.uploadDocumento(file))
          )
          this.$bvToast.toast(`${results.length} documento(s) enviado(s) com sucesso`, {
            title: 'Arquivo(s) anexado(s)!',
            variant: 'success',
            toaster: 'b-toaster-bottom-center',
            autoHideDelay: 5000,
            solid: true
          })
        }
        else throw new Error('Nenhum pedido de protesto encontrado!')
      } catch (error) {
        this.$bvToast.toast('Erro ao enviar documentos', {
          title: 'Erro ao anexar arquivo(s)!',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center',
          autoHideDelay: 5000,
          solid: true
        })
      } finally {
        this.loading = false
        this.$bvModal.hide('upload-modal')
      }
    },
    uploadDocumento(file) {
      const formData = new FormData()
      const token = localStorage.getItem("jwtToken");
      formData.append('file', file)
      formData.append("token", token);
      formData.append("cd_pedido_protesto", this.cd_pedido_protesto);

      return API.post(`protesto/v2/uploadDocumentoProtesto`, formData);
    },
    /* FIM FUNCOES MODAL UPLOAD DOCUMENTO */
  },
};
</script>
<style scoped>

#painel .card-text input.form-control:not(.is-invalid),
#painel .card-text select.custom-select:not(.is-invalid),
::v-deep .vs--searchable:not(.is-invalid) .vs__dropdown-toggle {
  border-color: var(--light-gray-color);
}
::v-deep .vs--searchable.is-invalid .vs__dropdown-toggle{
  border-color: #dc3545;
}
::v-deep .vs__dropdown-toggle {
  border-width: 2px;
  border-style: solid;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  text-align: left;
  letter-spacing: -1%;
  border-radius: 8px;
  //border: none;
  height: 49px;
  vertical-align: middle;
  color: var(--secondary-color);
  padding: 0 12px;
}
::v-deep .vs__dropdown-toggle .vs__clear {
  margin-bottom: 4px;
  margin-right: 18px;
}
::v-deep .vs--searchable.vs--open.is-invalid .vs__dropdown-toggle,
::v-deep .vs--open .vs__dropdown-toggle{
  border-color: var(--primary-color);
  border-radius: 8px 8px 0px 0px;
  //box-shadow: 0 0 0 0.2rem var(--primary-color);
  border-left: 0.2rem solid var(--primary-color);
  border-right: 0.2rem solid var(--primary-color);
  border-top: 0.2rem solid var(--primary-color);
}
::v-deep .vs--open .vs__selected{
  position: unset !important;
}
::v-deep .vs__dropdown-option {
  margin: 0.15rem;
  border-radius: 8px;
}

::v-deep .vs__dropdown-option--selected{
  background: color-mix(in srgb, var(--primary-color) 20%, transparent);
}
::v-deep .vs__dropdown-option--highlight{
  background: color-mix(in srgb, var(--secondary-color) 10%, transparent);
  color: var(--secondary-color);
}
::v-deep .vs__open-indicator {
  //fill: var(--azul-protesto);
}
::v-deep .vs__dropdown-menu {
  background: #ffffff 0% 0% no-repeat padding-box;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  text-align: left;
  letter-spacing: -1%;
  border-radius: 0px 0px 8px 8px;
  border: none;
  vertical-align: middle;
  color: var(--secondary-color);
  box-shadow:0px 20px 52px -27px rgba(0,0,0,0.15);
}
::v-deep .vs--open .vs__dropdown-menu {
  border-left: 0.2rem solid var(--primary-color);
  border-right: 0.2rem solid var(--primary-color);
  border-bottom: 0.2rem solid var(--primary-color);
}
::v-deep input[type="date"]::-webkit-calendar-picker-indicator {
  color: var(--azul-protesto);
}
#painel .form-control:focus,
#painel .card-text select.custom-select:focus {
  box-shadow: 0 0 0 0.2rem var(--primary-color);
}
#painel .card-body {
  border-radius: 22px;
  box-shadow: 0px 0px 15px 0 #D1DBE260;
}

  /*
  #painel .tab2-protesto h4{font: normal normal 200 20px/30px 'Kanit', sans-serif;}
  #painel .tab2-protesto label{font: normal normal 200 16px/20px 'Kanit', sans-serif;}
  */
#painel .tab-protesto label{font: normal normal 200 16px/20px 'Kanit', sans-serif;}
.btn-secondary {
  background: none;
  border: none;
  border-radius: 40px;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: var(--secondary-color);
  padding: 6px 20px;
  height: 49px;
}
.btn-secondary:hover, .btn-secondary:focus, .btn-secondary:active {
  background: color-mix(in srgb, var(--secondary-color) 10%, transparent);;
}
.btn-danger{
  border: none;
  border-radius: 40px;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  padding: 6px 20px;
  height: 49px;
}

.btn-success{
  border: none;
  border-radius: 40px;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  padding: 6px 20px;
  height: 49px;
}

.btn-primary{
  border: none;
  border-radius: 40px;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  padding: 6px 20px;
  height: 49px;
}

#painel h5{
  text-align: left;
  font: normal normal 200 20px/30px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: var(--navbar-gray-color);
}
#painel .btn-prosseguir{
  width: fit-content;
  padding: 6px 20px;
  height: 49px;
  background: var(--primary-color) 0% 0% no-repeat padding-box;
  border: none;
  border-radius: 40px;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
#painel .btn-adicionar-codevedor{
  width: fit-content;
  height: 49px;
  border: none;
  background: var(--primary-color) 0% 0% no-repeat padding-box;
  border-radius: 40px;
  text-align: center;
  font: normal normal 300 20px/15px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: #FFFFFF;
  padding: 0 30px;
}
#painel .btn-adicionar-codevedor svg{margin-left: 5px;}
#painel .card-header{font: normal normal 200 20px/41px 'Kanit', sans-serif; letter-spacing: -1%;padding: 13px 22px;}
#painel .card-header .infolet{background: var(--primary-color) 0% 0% no-repeat padding-box;border-radius: 100%;font: normal normal 400 16px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: #FFFFFF;padding: 0px 10px 0px 9.5px;left: 5px !important;position: relative;top: -1.5px;}
#painel .card-text .infolet{
  background: var(--secondary-color) 0% 0% no-repeat padding-box;
  border-radius: 100%;
  font: normal normal 400 11px/15px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: #FFFFFF;
  padding: 0px 7px 0px 6px;
  left: 3px;
  position: relative;
  top: -1.5px;
}

#painel h4{
  text-align: left;
  font: normal normal 200 20px/30px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: var(--secondary-color);
  margin: 0;
  margin-bottom: 1rem;
}
#painel hr{
  margin-top: 28px;
    margin-bottom: 17px;
}
#painel .card-text label{
  font: normal normal 200 16px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  margin-bottom: 6px;
  margin-top: 12px;
  margin-left: 12px;
}

#painel .card-text label i{
  font: italic normal 200 16px/20px 'Kanit', sans-serif;
}
#painel .card-text input.form-control,
#painel .card-text select.custom-select {
  border-width: 2px;
  border-style: solid;
  text-align: left;
  letter-spacing: -1%;
  border-radius: 8px;
  height: 49px;
  vertical-align: middle;
  color:var(--secondary-color);
  padding: 0 12px;
}
#painel .card-text select.custom-select{
  cursor: pointer;
}
#painel .card-text .select-arrow-down{
  border-left: 5px solid var(--azul-protesto);
  border-top: 5px solid var(--azul-protesto);
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  transform: rotate(225deg);
  width: 9px;
  height: 9px;
  position: absolute;
  bottom: 22px;
  right: 28px;
  cursor: pointer;
}
#painel .card-text input.form-control::placeholder{
  color: #A8A8A8;
}

#painel .container-pedidoprotesto{
  max-width: 964px;
  margin-left: calc((50vw - 964px / 2 ) - (296px + 5px + 5px + (3.8vw - 5px)));
}
#painel #frmProcuracao h1{
  text-align: left;
  font: normal normal 200 50px/55px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: var(--secondary-color);
  margin-top: 37px !important;
  margin-bottom: 25px !important;
}

#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  overflow-x: hidden;
  border-top: 1px solid #f1f1f1;
}
.lista-certidoes {
  color: #000;
}
.lista-certidoes b {
  font-size: 0.85rem;
  color: var(--main-azul);
}

a {
  color: #555;
}
.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
#loading-solicitante {
  vertical-align: 0;
  margin-left: -21px;
}
.load {
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spin {
  background: #fff;
  height: 80px;
  width: 80px;
  border-radius: 50vh;
  border-color: #209cee;
  border-top: 5px solid #209cee;
  animation: loading 3s linear infinite;
}
.loading {
  position: relative;
  color: #000;
  display: block !important;
  width: 100%;
}
@keyframes loading {
  100% {
    transform: rotate(360deg);
  }
}
.bold {
  font-weight: bold;
}

.esconder {
  display: none;
}
.mensagemErro {
  color: red;
}
#cabecalho {
  z-index: 0 !important;
}

#progress_bar {
  margin: 10px 0;
  padding: 3px;
  /* border: 1px solid #000; */
  font-size: 14px;
  clear: both;
  opacity: 0;
  -moz-transition: opacity 1s linear;
  -o-transition: opacity 1s linear;
  -webkit-transition: opacity 1s linear;
}
#progress_bar.loading {
  opacity: 1.0;
}
#progress_bar .percent {
  background-color: #10cf76;
  height: auto;
  width: 0;
}

.espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}
/* #painel > .row{justify-content: space-between;} */

#painel{scrollbar-width:none;}
#painel::-webkit-scrollbar{display:none;}
#painel h1 {text-align: left;font: normal normal bold 30px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 22px;}
#painelcontainerfluid{margin-top: 37px;}
@media (max-width:1600px) and (min-width:1400px){
  .espaco-menu{margin-left: calc(20px - 5px) !important;}  
  #painelcontainerfluid{padding-right: 20px !important;}
}
@media (max-width:1399px) and (min-width:1200px){
  .espaco-menu{margin-left: calc(10px - 5px) !important;}
  #painelcontainerfluid{padding-right: 10px !important;}
}
@media (max-width:1199px){
  #painel {padding:0 17px;}
  #painel > .row{
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }
  .col-lg-9{max-width: none;flex: 1 1 100%;padding: 0;}
  #painelcontainerfluid{padding:0px !important;}
}
@media (max-width:1700px) and (min-width:1300px){
  #painel .container-pedidoprotesto{margin-left: 1vw;}
}
@media (max-width:1300px) and (min-width:1200px){
  #painel .container-pedidoprotesto{
    margin-left: 310px;
    max-width: calc(100vw - 310px);}
}
@media (max-width:1199px) {
  #painel .container-pedidoprotesto {
    margin: 0 auto !important;
    max-width: calc(100vw - 20px);
  }
}
select[disabled="disabled"]{
  cursor: not-allowed !important;
}
.breadcrumb{margin-left: 0px;background: unset;}
.breadcrumb a, .breadcrumb span, .breadcrumb-item + .breadcrumb-item::before{font: normal normal 200 16px/20px 'Kanit', sans-serif;}
.breadcrumb-item + .breadcrumb-item::before{float:unset;}
.breadcrumb a{color:var(--primary-color);}
.breadcrumb-item + .breadcrumb-item::before{color:var(--primary-color);}
.breadcrumb span{color:var(--secondary-color);}
.breadcrumb a.disabled{text-decoration:none;cursor:default;}
.btn-voltar {display: flex;align-items: center;margin-left: auto;letter-spacing: 0px;text-decoration: none;justify-content: flex-end !important;margin-bottom: 20px;}
.btn-voltar img{width: 20px;height: 20px;margin-left: 6px;}


.btn.btn-info{
  width: 160px;
  height: 44px;
  font: normal normal 500 16px/20px 'Kanit', sans-serif;
  border-radius: 5px;
  opacity: 1;
  border: none;
  outline: none;
}
.btn.btn-info:disabled{
  background-color: #17a2b888;
  border-color: #17a2b888;
}
</style>
